//#region imports
import React, { useState } from 'react';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import SearchIcon from '@mui/icons-material/Search';
import { POHeaderLookup } from '../Lookups/POHeaderLookup';
import { Level2Lookup } from '../Lookups/Level2Lookup';
import { Level3Lookup } from '../Lookups/Level3Lookup';
import { CostCodesLookup } from '../Lookups/CostCodesLookup';
import { stringIsNullOrEmpty, blankStringIfNullOrEmpty, formatNumber, zeroIfNull, getRoutingLevelOfApproval, calculateTax, getDisplayName } from '../Common/Utilities';
import { toast } from 'react-toastify';
import { httpGet, httpPost } from '../../HttpRequestHandling/httpRequestHandler';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
//import DeleteIcon from '@mui/icons-material/Delete';
import AddBoxIcon from '@mui/icons-material/AddBox';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import Tooltip from '@mui/material/Tooltip';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { DataGridPro } from '@mui/x-data-grid-pro';
import Checkbox from '@mui/material/Checkbox';
import TableSortLabel from '@mui/material/TableSortLabel';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { styled } from '@mui/material/styles';
import ClearIcon from '@mui/icons-material/Clear';
import { invoiceEditorDetailModel } from '../../Models';
import MergeIcon from '@mui/icons-material/Merge';
import CallSplitIcon from '@mui/icons-material/CallSplit';
import HistoryIcon from '@mui/icons-material/History';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useInvoice } from './InvoiceDocumentEditorContext';
import { Constants } from '../Common/Constants';
import { isApprovalLevelBreached } from './InvoiceDocumentEditorFunctions';


//#endregion
//#region styled components
const StyledTableContainer = styled(TableContainer)(({ theme }) => {
	return {
		'& .MuiTableCell-root': {
			fontSize: '0.75rem',
			padding: '8px',
			color: 'inherit',
			border: 0,
			borderBottom: '1px solid rgba(224, 224, 224, 1)',
			cursor: 'pointer',
			margin: 0,
			outline: 0,
			padding: '0 10px 0 10px',
			//userSelect: 'none',
			borderRadius: 0,
			textDecoration: 'none',
			//	backgroundColor: 'white',
			height: '52px'

		},
		'& .MuiTableRow-hover:hover': {
			backgroundColor: 'white !important'
		},
		'& .MuiTableCell-root .MuiInput-input,& .MuiTableCell-root select': {

			boxSizing: 'border-box',
			color: '#414141',
			height: '34px',
			padding: '7px 10px 7px 10px',
			width: '66%',
			outline: 'none',
			border: '1px solid #c6c6c6',
			borderRadius: 6,
			transition: '0.3s ease-in-out all'
		},
		'& .MuiTableCell-root .MuiInput-input-error': {

			border: '1px solid red !important',
		},
		'&::-webkit-scrollbar': {
			height: '0.5em',
			width: '0.2em'
		},
		'&::-webkit-scrollbar-thumb:vertical,&::-webkit-scrollbar-thumb:horizontal': {
			background: '#B2b2b2', borderRadius: 2, opacity: '0.5'
		},
		'& input[type=number]::-webkit-outer-spin-button,input[type=number]::-webkit-inner-spin-button': {
			'-webkit-appearance': 'none',
			margin: 0
		},
		'& input[type=number]': {
			'-moz-appearance': 'textfield'
		}
	}
});


//TablePagination
const StyledTablePagination = styled(TablePagination)(({ theme }) => {
	return {
		'& p': {
			margin: 0
		}
	}
});



//#endregion 

//#region InvoiceDocumentEditorGrid
export default function InvoiceDocumentEditorGrid(props) {
	//#region Initializers

	const overRideAllChecks = props.overrideAllChks;
	const { state: invoiceState, setState: setInvoiceState, partialPostSeqIdsMap, triggerValidation, validateIfNotEmpty } = useInvoice();
	const { mode: editorMode } = invoiceState;
	const isPartialPostMode = Boolean(props.partialPostMode) || editorMode === 'PartialPost';
	const partialEditableIONumberSet = props.partialEditableIONumberSet || null;
	const partialMoInvoiceMap = props.partialMoInvoiceMap || null;


	//#region states
	let [state, setState] = useState({
		isDirty: false,
		openPOHeaderDialog: false,
		openLevel2Dialog: false,
		openLevel3Dialog: false,
		openCostCodesDialog: false,
		vendor: null,
		uncollapsed: true,
		openDeleteConfirmation: false,
		deleteRowData: null,
		taxes: props.taxes,
		addClickUpdate: false,
		deleteClickUpdate: false,
		openDeleteSelectedConfirmation: false,
		openCommentApprovalRejection: false
	});

	const [isGridDataValid, setIsGridDataValid] = React.useState(false);
	const [currentEditRow, setCurrentEditRow] = React.useState(null);
	const [selectedRows, setSelectedRows] = React.useState(new Set());
	const [sortedField, setSortedField] = React.useState('');
	const [orderBy, setOrderBy] = React.useState('');
	const [pageSize, setpageSize] = React.useState(5);
	const [page, setPage] = React.useState(0);
	const [searchText, setSearchText] = React.useState('');
	const invalidRowsList = invoiceState.invalidRowsList || new Set();
	const invalidRowsMessage = invoiceState.invalidRowsMessage || {};
	const [isMergeButtonDisabled, setisMergeButtonDisabled] = React.useState(true);
	const [isSearchButtonDisabled, setisSearchButtonDisabled] = React.useState(true);
	const [openCommentDialog, setOpenCommentDialog] = useState(false);
	const [comment, setComment] = useState('');
	const [actionType, setActionType] = useState('');
	const [nextleveldesc, setnextleveldesc] = useState('');
	const [isApproveButtonDisabled, setisApproveButtonDisabled] = React.useState(true);
	const [isRejectButtonDisabled, setisRejectButtonDisabled] = React.useState(true);
	const [isAddButtonDisabled, setisAddButtonDisabled] = React.useState(true);
	const [showMyLinesOnly, setShowMyLinesOnly] = useState(false);
	const [level3RefreshKey, setLevel3RefreshKey] = useState(0);
	const [taxCodeChange, setTaxCodeChange] = useState(false);


	// Lookup mode is controlled by configuration first.
	// Only modelDefId=1 with insertionLevelMatchingCriteria=1 should use
	// placement-level lookup behavior.
	const isPlacementMatchingEnabled =
		Number(invoiceState.invoiceDocument?.modelDefId) === 1 &&
		Number(
			invoiceState.invoiceDocument?.insertionLevelMatchingCriteria
			?? props.poHeaderLookupInfo?.insertionLevelMatchingCriteria
		) === 1;

	const hasPlacementLevelMatch = (row) => {
		const sessionMode = (row?.ioSessionMode || invoiceState.invoiceDocument?.ioSessionMode || '')
			.toString()
			.trim()
			.toLowerCase();

		// Match the same "placement mode" determination used by isRowPlacementLocked:
		// any non-empty mode other than 'io' (e.g. 'placement' or 'partial') counts as
		// placement-level matching. A strict === 'placement' check missed rows whose
		// session mode was persisted using an equivalent, non-'io' value.
		const isIoMode = !sessionMode || sessionMode === 'io';

		return isPlacementMatchingEnabled &&
			!isIoMode &&
			Array.isArray(row?.placements) &&
			row.placements.length > 0;
	};

	const formatPlacementDate = (dStr) => {
		if (!dStr) return '';

		const raw = dStr.toString().trim();

		const isoDateMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s].*)?$/);
		if (isoDateMatch) {
			const [, year, month, day] = isoDateMatch;
			return `${month}/${day}/${year}`;
		}

		return raw;
	};

	const placementDetailsColumns = [
		{ field: 'placementId', headerName: 'Placement ID', width: 120, sortable: false },
		{
			field: 'placementName',
			headerName: 'Placement Name',
			width: 180,
			sortable: false,
			renderCell: (params) => (
				<Box
					title={params.value || ''}
					sx={{
						width: '100%',
						whiteSpace: 'normal',
						overflowWrap: 'break-word',
						lineHeight: '1.2em',
						maxHeight: '2.4em',
						overflow: 'hidden',
						display: '-webkit-box',
						WebkitLineClamp: 2,
						WebkitBoxOrient: 'vertical'
					}}
				>
					{params.value}
				</Box>
			)
		},
		{ field: 'startDate', headerName: 'Start Date', width: 100, sortable: false, valueFormatter: (params) => formatPlacementDate(params.value) },
		{ field: 'endDate', headerName: 'End Date', width: 100, sortable: false, valueFormatter: (params) => formatPlacementDate(params.value) },
		{ field: 'costType', headerName: 'Cost Type', width: 90, sortable: false, valueGetter: (params) => params.row?.costType || params.row?.costMethod || '' },
		{ field: 'amount', headerName: 'Amount', width: 90, align: 'right', headerAlign: 'right', sortable: false, valueGetter: (params) => Number(params.row?.allocAmount ?? params.row?.netAmount ?? 0), valueFormatter: (params) => formatNumber(params.value) }
	];

	const renderPlacementDetails = (row) => {
		if (!hasPlacementLevelMatch(row)) return null;

		const placements = Array.isArray(row?.placements) ? row.placements : [];
		const gridRows = placements.map((p, idx) => ({ id: p.placementId ?? idx, ...p }));

		const tooltipContent = (
			<Box sx={{ p: 1, width: 700 }}>
				{placements.length === 0 ? (
					<Typography variant="body2" sx={{ py: 1, color: '#6b7280' }}>No placements found.</Typography>
				) : (
					<Box sx={{ height: Math.min(52 + gridRows.length * 36, 230), '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 500, color: '#000000' } }}>
						<DataGridPro
							id="placement-details-grid"
							rows={gridRows}
							columns={placementDetailsColumns}
							hideFooter
							disableColumnMenu
							disableSelectionOnClick
							disableColumnSort
							density="compact"
							getRowHeight={() => 'auto'}
					/>
					</Box>
				)}
			</Box>
		);

		return (
			<Tooltip
				title={tooltipContent}
				arrow
				placement={'bottom-start'}
				componentsProps={{ tooltip: { sx: { bgcolor: '#ffffff', color: '#000000', border: '1px solid #e0e0e0', boxShadow: 3, maxWidth: 'none' } }, arrow: { sx: { color: '#ffffff' } } }}
			>
						<img id={`placement-details-${row?.seqId}`} src="/images/placement_detail_icon.png" alt="Placement Details" style={{ width: 20, height: 20 }} />
			</Tooltip>
		);
	};

	// Per-row determination of whether the ioInvoiceAmount field must be locked.
	// Keep it editable for null/empty or IO session mode when restriction is off.
	const isRowPlacementLocked = React.useCallback((row) => {
		if (!row) return false;

		const sessionMode = (row.ioSessionMode || invoiceState.invoiceDocument?.ioSessionMode || '').toString().trim().toLowerCase();
		const insertionLevelMatchingCriteria =
			invoiceState.invoiceDocument?.insertionLevelMatchingCriteria
			?? props.poHeaderLookupInfo?.insertionLevelMatchingCriteria;
		const disallowPartialPlacementConsumption =
			invoiceState.invoiceDocument?.disallowPartialPlacementConsumption
			?? props.poHeaderLookupInfo?.disallowPartialPlacementConsumption;

		const isModelDefOne = Number(invoiceState.invoiceDocument?.modelDefId) === 1;
		const isRestrictEnabled = Number(disallowPartialPlacementConsumption) === 1;
		const isPlacementLevelMatching = Number(insertionLevelMatchingCriteria) === 1;
		const isIoMode = !sessionMode || sessionMode === 'io';
		const hasPlacements = Array.isArray(row.placements) && row.placements.length > 0;

		if (!isModelDefOne) return false;
		if (isRestrictEnabled && isPlacementLevelMatching) return true;

		return isPlacementLevelMatching && !isIoMode && hasPlacements;
	}, [
		invoiceState.invoiceDocument?.modelDefId,
		invoiceState.invoiceDocument?.ioSessionMode,
		invoiceState.invoiceDocument?.insertionLevelMatchingCriteria,
		invoiceState.invoiceDocument?.disallowPartialPlacementConsumption,
		props.poHeaderLookupInfo?.insertionLevelMatchingCriteria,
		props.poHeaderLookupInfo?.disallowPartialPlacementConsumption
	]);

	const maxRoutingLevel = React.useMemo(() => {
		return getRoutingLevelOfApproval(props.info.modelDefId);
	})

	//#endregion

	//React.useEffect(() => {

	//	if (
	//		props.originalInvoiceDocumentStatus
	//	) {
	//		setInvoiceState(prev => ({
	//			...prev,
	//			invoiceDocumenretLineImage: invoiceState?.invoiceDocument?.invoiceDocumentEditorDetails,
	//		}))
	//	}
	//}, [props.originalInvoiceDocumentStatus, invoiceState]);


	React.useEffect(() => {
	}, [isGridDataValid])

	React.useEffect(() => {
		const lastPage = getLastPage();
		if (state.addClickUpdate) {
			setPage(lastPage - 1);
			setState({ ...state, addClickUpdate: false })
		}
		if (state.deleteClickUpdate) {
			let p;
			if (page > lastPage - 1) {
				p = lastPage - 1;
			} else {
				p = page;
			}
			setPage(p < 0 ? 0 : p);
			setState({ ...state, deleteClickUpdate: false })
		}
	}, [state.addClickUpdate, state.deleteClickUpdate])


	React.useEffect(() => {
		if (props.info.modelDefId === 3) {
			let total = props.broadCastInvoiceTotal;
			let taxCode = props.broadCastTaxCode;
			let existingLine = invoiceState.invoiceDocument?.invoiceDocumentEditorDetails[0];
			let lineTotal = existingLine?.ioInvoiceAmount || 0;
			let lineTax = existingLine?.taxCode || '';
			let taxCodeChanged = taxCode != lineTax;
			let amountChanged = total != lineTotal;
			if (amountChanged || taxCodeChanged) {
				let line = {
					invoiceDocumentId: invoiceState.invoiceDocument?.invoiceDocumentId,
					companyCode: invoiceState.invoiceDocument?.companyCode,
					lineStatus: invoiceState.invoiceDocument?.invoiceDocumentStatusId >= 50 ? 50 : 40,
					...existingLine,
					ioInvoiceAmount: props.broadCastInvoiceTotal,
					taxCode: taxCode,
					// Tax code change always resets manual tax-amount override, mirroring the
					// grid row's onChange handler for the Tax Code column (row.isTaxManuallyChanged = false)
					// so a manual override from a previous tax code never leaks into a newly selected one.
					isTaxManuallyChanged: taxCodeChanged ? false : existingLine?.isTaxManuallyChanged
				};
				// Tax code change: always fully recompute (same as non-broadcast rows).
				// Amount change on a manually-overridden line: recompute so proportional
				// redistribution re-applies against the new invoice amount, mirroring
				// onIoInvoiceAmountBlur for non-broadcast grid rows.
				if (props.braodCastTaxChanged || (amountChanged && line.isTaxManuallyChanged)) {
					calculateTaxAmount(line.taxCode, line);
				}
				setInvoiceState({
					...invoiceState,
					invoiceDocument: {
						...invoiceState.invoiceDocument,
						invoiceDocumentEditorDetails: [
							{ ...line, ioInvoiceAmount: props.broadCastInvoiceTotal }
						]

					}
				})
			}

		}

	}, [props.broadCastInvoiceTotal, props.broadCastTaxCode, props.braodCastTaxChanged])


	const getLastPage = () => {
		const details = filteredRows;
		return Math.abs(Math.ceil(details.length / pageSize));
	}
	React.useEffect(() => {
		if (getLastPage) {
			const _lp = getLastPage() - 1;
			if (page > _lp) {
				setPage(_lp < 0 ? 0 : _lp)
			}
			else { setPage(0) }
		}
	}, [pageSize])

	React.useEffect(() => {
		var selectedRowsData = invoiceState.invoiceDocument.invoiceDocumentEditorDetails.filter(row => selectedRows.has(row.seqId));
		var uniquePONumbers = new Set(selectedRowsData.map(row => (row.poCode || row.ioNumber || '').trim() || null));
		const hasInvalidLineStatus = selectedRowsData.some(row => row.lineStatus >= 70 && row.lineStatus != 100);

		let canMerge = false;
		if (invoiceState.invoiceDocument.insertionLevelMatchingCriteria === 1) {
			const uniqueClientCodes = new Set(selectedRowsData.map(row => row.clientCode));
			const uniqueTaxCodes = new Set(selectedRowsData.map(row => row.taxCode));
			canMerge = uniquePONumbers.size === 1 && uniqueTaxCodes.size === 1;
		} else {
			canMerge = uniquePONumbers.size === 1 || (uniquePONumbers.size === 2 && uniquePONumbers.has(null));
		}

		if (selectedRowsData.length === 1 || selectedRowsData.length === 0 || hasInvalidLineStatus || !canMerge) {
			setisMergeButtonDisabled(true);
		} else {
			setisMergeButtonDisabled(false);
		}
	}, [selectedRows, invoiceState.invoiceDocument.invoiceDocumentEditorDetails]);

	React.useEffect(() => {
		var selectedRowsData = invoiceState.invoiceDocument.invoiceDocumentEditorDetails.filter(row => selectedRows.has(row.seqId));
		const hasInvalidLineStatus = selectedRowsData.some(row => row.lineStatus >= 70 && row.lineStatus != 100);

		if (selectedRowsData.length === 1 && !hasInvalidLineStatus) {
			setisSearchButtonDisabled(false);
		} else {
			setisSearchButtonDisabled(true);
		}
	}, [selectedRows, invoiceState.invoiceDocument.invoiceDocumentEditorDetails]);

	React.useEffect(() => {
		var selectedRowsData = invoiceState.invoiceDocument.invoiceDocumentEditorDetails.filter(row => selectedRows.has(row.seqId));
		const hasValidLineStatus = selectedRowsData.every(row => row.lineStatus >= 50 && [60, 80, 100].indexOf(row.lineStatus) === -1);
		const allDescriptionsEmpty = invoiceState.invoiceDocument.invoiceDocumentEditorDetails.length > 0 &&
			invoiceState.invoiceDocument.invoiceDocumentEditorDetails.every(row => row.nextLevelApprovalDescription === "");
		const allApproved = selectedRowsData.length > 0 && selectedRowsData.every(row => row.statusDescription === 'Approved');
		let hasMissingRequiredFields = false;

		if (invoiceState.invoiceDocument.modelDefId === 1) {
			hasMissingRequiredFields = selectedRowsData.some(row => !row.poCode && !row.ioNumber);
		} else if (invoiceState.invoiceDocument.modelDefId === 2) {
			hasMissingRequiredFields = selectedRowsData.some(row =>
				!row.level2Key || !row.level3Key || !row.rTypeName
			);
		}

		if (selectedRowsData.length === 0 || allApproved || hasMissingRequiredFields) {
			setisApproveButtonDisabled(true);
		} else {
			setisApproveButtonDisabled(false);
		}
		if (selectedRowsData.length === 0 || !hasValidLineStatus) {
			setisRejectButtonDisabled(true);
		} else {
			setisRejectButtonDisabled(false);
		}
		if (props.readOnly) {
			setisAddButtonDisabled(true);
		} else {
			setisAddButtonDisabled(false);
		}
	}, [selectedRows, props.readOnly, invoiceState.invoiceDocument.invoiceDocumentEditorDetails]);



	React.useEffect(() => {
		if (!invoiceState?.invoiceDocumentImage?.invoiceDocumentEditorDetails ||
			invoiceState?.invoiceDocumentImage?.invoiceDocumentEditorDetails?.length !== invoiceState.invoiceDocument.invoiceDocumentEditorDetails?.length
			|| !isDataSame(invoiceState?.invoiceDocumentImage?.invoiceDocumentEditorDetails, invoiceState?.invoiceDocument?.invoiceDocumentEditorDetails)
		) {
			props.setLinesDirty();
		}
	}, [invoiceState.invoiceDocument.invoiceDocumentEditorDetails]);


	//#region Parent State

	React.useImperativeHandle(props.stateRef, () => {
		return {
			isGridDataValid: invoiceState.isGridDataValid,
			//setDetailsOnVendorChange: setDetailsOnVendorChange,
			setDetailsOnserviceTermBlur: setDetailsOnserviceTermBlur,
			setInvoiceDetailsOnVendorChange: setInvoiceDetailsOnVendorChange,
			setDetailsOnPOChange: setDetailsOnPOChange,
			invalidRowsList: invoiceState.invalidRowsList,
			invalidRowsMessage: invoiceState.invalidRowsMessage,
			resetGridData: resetGridData,
			clearIONumberHandler: clearIONumberHandler,
			triggerGridValidation: triggerValidation,
			calculateTaxAmount: calculateTaxAmount
		}
	});

	const resetGridData = (initialInvoiceDocument) => {
		const totalRowsAfterMerge = initialInvoiceDocument?.invoiceDocumentEditorDetails.length;
		const newPage = Math.min(Math.floor(totalRowsAfterMerge / pageSize), page);
		setPage(newPage);
	}

	// triggerGridValidation replaced by context's triggerValidation

	const stateUpliftMethods = React.useMemo(() => {
		return {
			setParentState: props.setParentState, messageDialog: props.messageDialog, duplicateCheck: state.duplicateCheck, updateView: props.updateView,
			searchIONumber_clickHandler: props.searchIONumber_clickHandler,
			routingHistory_clickHandler: props.routingHistory_clickHandler
		}
	})

	React.useEffect(() => {
		if (props.editable) {
			validateAllRows();
		} else {
			setIsGridDataValid(true);
		}
	}, [stateUpliftMethods,
		invoiceState.invoiceDocument?.isPOCodeValid,
		invoiceState.invoiceDocument?.invoiceDocumentEditorDetails,
		invoiceState.invoiceDocument?.invoiceDocumentEditorDetails?.length,
		invoiceState.invoiceDocument?.vendor, isGridDataValid])





	const setDetailsOnserviceTermBlur = React.useCallback((poHeader) => {
		const details = invoiceState.invoiceDocument.invoiceDocumentEditorDetails.map(function (detail, index) {
			var poHeader = poHeaders.find(poHeader => !stringIsNullOrEmpty(poHeader.poCode) && !stringIsNullOrEmpty(detail.ioNumber) && poHeader.poCode.trim() === detail.ioNumber.trim());
			if (poHeader) {
				detail.deliveryAmount = poHeader.deliveryAmount;
			}
		});
		setInvoiceState({ ...invoiceState, invoiceDocument: { ...invoiceState.invoiceDocument, invoiceDocumentEditorDetails: details } })
	})

	const setInvoiceDetailsOnVendorChange = React.useCallback((parentInvoiceObject, data) => {
		if (stringIsNullOrEmpty(parentInvoiceObject.poCode)) {
			invoiceState.invoiceDocument.invoiceDocumentEditorDetails.map(function (invoiceDocumentEditorDetail, index) {
				var row = data.find(d => d.seqId === invoiceDocumentEditorDetail.seqId);
				invoiceDocumentEditorDetail.level2Key = ''; /*row.level2Key;*/
				invoiceDocumentEditorDetail.isLevel2KeyValid = 'N' /*row.isLevel2KeyValid;*/
				invoiceDocumentEditorDetail.level3Key = ''; /*row.level3Key;*/
				invoiceDocumentEditorDetail.isLevel3KeyValid = 'N' /*row.isLevel3KeyValid;*/
				invoiceDocumentEditorDetail.costType = null; /*row.costType;*/
				invoiceDocumentEditorDetail.resType = null;
				invoiceDocumentEditorDetail.rTypeName = ''; //row.rTypeName;
				invoiceDocumentEditorDetail.isCostCodesValid = 'N' /*row.isCostCodesValid;*/
				///////////////////////////////////////////////////
				invoiceDocumentEditorDetail.netCost = 0.00;
				invoiceDocumentEditorDetail.matchToDateNet = 0.00;
				invoiceDocumentEditorDetail.remainingAmount = 0.00;
				invoiceDocumentEditorDetail.poRequiredFlag = 'N';
				invoiceDocumentEditorDetail.tolerancePOFlag = 'N';
				invoiceDocumentEditorDetail.tolerancePOAmount = 0.00;

			});
		}
		else {
			if (invoiceState.invoiceDocument.invoiceDocumentEditorDetails.length === 0) {
				data.map(function (poDetail, index) {
					var invoiceDocumentEditorDetail = poDetail;
					invoiceDocumentEditorDetail.invoiceDocumentId = invoiceState.invoiceDocument?.invoiceDocumentId;
					invoiceDocumentEditorDetail.seqId = index + 1;
					invoiceDocumentEditorDetail.ioInvoiceAmount = poDetail.remainingAmount;
					invoiceState.invoiceDocument.invoiceDocumentEditorDetails.push(invoiceDocumentEditorDetail);
				});
			}
			else if (data.length === 1) {
				invoiceState.invoiceDocument.invoiceDocumentEditorDetails.map(function (invoiceDocumentEditorDetail, index) {
					invoiceDocumentEditorDetail.level2Key = data[0].level2Key;
					invoiceDocumentEditorDetail.isLevel2KeyValid = data[0].isLevel2KeyValid;
					invoiceDocumentEditorDetail.level3Key = data[0].level3Key;
					invoiceDocumentEditorDetail.isLevel3KeyValid = data[0].isLevel3KeyValid;
					invoiceDocumentEditorDetail.costType = data[0].costType;
					invoiceDocumentEditorDetail.resType = data[0].resType;
					invoiceDocumentEditorDetail.rTypeName = data[0].rTypeName;
					invoiceDocumentEditorDetail.isCostCodesValid = data[0].isCostCodesValid;
					invoiceDocumentEditorDetail.poRequiredFlag = data[0].poRequiredFlag;
					invoiceDocumentEditorDetail.tolerancePOFlag = data[0].tolerancePOFlag;
					invoiceDocumentEditorDetail.tolerancePOAmount = data[0].tolerancePOAmount;
					invoiceDocumentEditorDetail.netCost = data[0].netCost;
					invoiceDocumentEditorDetail.matchToDateNet = data[0].matchToDateNet;
					invoiceDocumentEditorDetail.remainingAmount = data[0].remainingAmount;
				});
			}
			else {
				invoiceState.invoiceDocument.invoiceDocumentEditorDetails.map(function (invoiceDocumentEditorDetail, index) {
					var verifiedRow = data.find(d => d.level2Key != null && d.level2Key === invoiceDocumentEditorDetail.level2Key &&
						d.level3Key != null && d.level3Key === invoiceDocumentEditorDetail.level3Key &&
						d.costType != null && d.costType === invoiceDocumentEditorDetail.costType &&
						d.resType != null && d.resType === invoiceDocumentEditorDetail.resType);
					if (verifiedRow != null) {
						return;
					}
					var defaultLevel2Key = "";
					var isLevel2KeyValid = 'N';
					var defaultPoRequiredFlag = 'N';
					var defaultTolerancePOFlag = 'N';
					var defaultTolerancePOAmount = 0.00;
					var defaultLevel3Key = "";
					var isLevel3KeyValid = 'N';
					var defaultCostType = null;
					var defaultResType = null;
					var defaultRTypeName = "";
					var isCostCodesValid = 'N';
					var defaultNetCost = 0.00;
					var defaultMatchToDateNet = 0.00;
					var defaultRemainingAmount = 0.00;
					var verifiedRows = data.filter(d => d.level2Key != null && d.level2Key === invoiceDocumentEditorDetail.level2Key);
					if (verifiedRows != null && verifiedRows.length > 0) {
						verifiedRow = verifiedRows[0];
						var distinctLevel2Keys = uniqueBy(verifiedRows, ["level2Key"]);
						if (distinctLevel2Keys.length === 1) {
							defaultLevel2Key = verifiedRow.level2Key;
							isLevel2KeyValid = 'Y';
							defaultPoRequiredFlag = verifiedRow.poRequiredFlag;
							defaultTolerancePOFlag = verifiedRow.tolerancePOFlag;
							defaultTolerancePOAmount = verifiedRow.tolerancePOAmount;
						}
						verifiedRows = verifiedRows.filter(idd => idd.level3Key != null && idd.level3Key === invoiceDocumentEditorDetail.level3Key);
						if (verifiedRows != null && verifiedRows.length > 0) {
							verifiedRow = verifiedRows[0];
							var distinctLevel3Keys = uniqueBy(verifiedRows, ["level3Key"]);
							if (distinctLevel3Keys.length === 1) {
								defaultLevel3Key = verifiedRow.level3Key;
								isLevel3KeyValid = 'Y';
							}
							verifiedRows = verifiedRows.filter(idd => idd.costType != null && invoiceDocumentEditorDetail.costType != null && idd.costType === invoiceDocumentEditorDetail.costType &&
								idd.resType != null && invoiceDocumentEditorDetail.resType != null && idd.resType === invoiceDocumentEditorDetail.resType);
							if (verifiedRows != null && verifiedRows.length > 0) {
								verifiedRow = verifiedRows[0];
								var distinctCostTypes = uniqueBy(verifiedRows, ["costType", "resType"]);
								if (distinctCostTypes.length === 1) {
									defaultCostType = verifiedRow.costType;
									defaultResType = verifiedRow.resType;
									defaultRTypeName = verifiedRow.rTypeName;
									isCostCodesValid = 'Y';
									defaultNetCost = verifiedRow.netCost;
									defaultMatchToDateNet = verifiedRow.matchToDateNet;
									defaultRemainingAmount = verifiedRow.remainingAmount;
								}
							}
							else {
								invoiceDocumentEditorDetail.costType = defaultCostType;
								invoiceDocumentEditorDetail.resType = defaultResType;
								invoiceDocumentEditorDetail.rTypeName = defaultRTypeName;
								invoiceDocumentEditorDetail.isCostCodesValid = isCostCodesValid;
								invoiceDocumentEditorDetail.netCost = defaultNetCost;
								invoiceDocumentEditorDetail.matchToDateNet = defaultMatchToDateNet;
								invoiceDocumentEditorDetail.remainingAmount = defaultRemainingAmount;
							}
						}
						else {
							invoiceDocumentEditorDetail.level3Key = defaultLevel3Key;
							invoiceDocumentEditorDetail.isLevel3KeyValid = isLevel3KeyValid;
							invoiceDocumentEditorDetail.costType = defaultCostType;
							invoiceDocumentEditorDetail.resType = defaultResType;
							invoiceDocumentEditorDetail.rTypeName = defaultRTypeName;
							invoiceDocumentEditorDetail.isCostCodesValid = isCostCodesValid;
							invoiceDocumentEditorDetail.netCost = defaultNetCost;
							invoiceDocumentEditorDetail.matchToDateNet = defaultMatchToDateNet;
							invoiceDocumentEditorDetail.remainingAmount = defaultRemainingAmount;
						}
					}
					else {
						invoiceDocumentEditorDetail.level2Key = defaultLevel2Key;
						invoiceDocumentEditorDetail.isLevel2KeyValid = isLevel2KeyValid;
						invoiceDocumentEditorDetail.poRequiredFlag = defaultPoRequiredFlag;
						invoiceDocumentEditorDetail.tolerancePOFlag = defaultTolerancePOFlag;
						invoiceDocumentEditorDetail.tolerancePOAmount = defaultTolerancePOAmount;
						invoiceDocumentEditorDetail.level3Key = defaultLevel3Key;
						invoiceDocumentEditorDetail.isLevel3KeyValid = isLevel3KeyValid;
						invoiceDocumentEditorDetail.costType = defaultCostType;
						invoiceDocumentEditorDetail.resType = defaultResType;
						invoiceDocumentEditorDetail.rTypeName = defaultRTypeName;
						invoiceDocumentEditorDetail.isCostCodesValid = isCostCodesValid;
						invoiceDocumentEditorDetail.netCost = defaultNetCost;
						invoiceDocumentEditorDetail.matchToDateNet = defaultMatchToDateNet;
						invoiceDocumentEditorDetail.remainingAmount = defaultRemainingAmount;
					}
				});
			}
		}
		// Vendor change resets the line's approval progress the same way the model 1/3 path
		// does in changeVendorYes_clickHandler — otherwise lineStatus stays at its pre-change
		// value and the Approval Status column/left border strip keep rendering as if the line
		// were still routed/approved.
		invoiceState.invoiceDocument.invoiceDocumentEditorDetails.forEach(function (invoiceDocumentEditorDetail) {
			invoiceDocumentEditorDetail.lineStatus = 40;
			invoiceDocumentEditorDetail.statusDescription = null;
			invoiceDocumentEditorDetail.nextLevelApprovalDescription = "";
			invoiceDocumentEditorDetail.isDirty = true;
			invoiceDocumentEditorDetail.changeType = 2;
		});
		setInvoiceState({ ...invoiceState, invoiceDocument: { ...invoiceState.invoiceDocument, invoiceDocumentEditorDetails: invoiceState.invoiceDocument.invoiceDocumentEditorDetails.map(e => e) } })
	})

	const setDetailsOnPOChange = React.useCallback((selectedRows, additionalPOHeaders, taxCode) => {
		if (!selectedRows.poCode) {
			return;
		}
		const invoiceDocument = invoiceState.invoiceDocument || {};
		let updatedInvoiceDetails = [...(invoiceDocument.invoiceDocumentEditorDetails || [])];
		const firstPOHeader = additionalPOHeaders[0];

		selectedRows.ioNumber = firstPOHeader.poCode.trim();
		selectedRows.poCode = firstPOHeader.poCode.trim();
		selectedRows.poAmount = firstPOHeader.poAmount;
		selectedRows.consumedAmount = firstPOHeader.consumedAmount;
		selectedRows.deliveryAmount = firstPOHeader.deliveryAmount;
		selectedRows.hasAuthority = firstPOHeader.hasAuthority;
		selectedRows.tolerancePOFlag = firstPOHeader.tolerancePOFlag;
		selectedRows.tolerancePOAmount = firstPOHeader.tolerancePOAmount;
		selectedRows.taxCode = taxCode;
		selectedRows.clientCode = firstPOHeader.clientCode;
		selectedRows.mediaType = firstPOHeader.mediaType;
		selectedRows.hasPlacementAllocations = firstPOHeader.hasPlacementAllocations || false;
		selectedRows.placementAllocations = firstPOHeader.placementAllocations || [];
		if (firstPOHeader.amount !== undefined) {
			selectedRows.amount = firstPOHeader.amount;
		}
		if (taxCode) {
			calculateTaxAmount(taxCode, selectedRows);
		}

		if (additionalPOHeaders.length > 1) {
			selectedRows.ioInvoiceAmount = (firstPOHeader.allocAmount).toFixed(2);
		} else if (firstPOHeader.hasPlacementAllocations && firstPOHeader.allocAmount !== undefined) {
			selectedRows.ioInvoiceAmount = parseFloat(firstPOHeader.allocAmount).toFixed(2);
		}

		selectedRows.isIONumberValid = 'Y';
		selectedRows.isIOUpdated = true;
		selectedRows.isDirty = true;

		updatedInvoiceDetails = updatedInvoiceDetails.map(row => row.seqId === selectedRows.seqId ? selectedRows : row);

		additionalPOHeaders.slice(1).forEach(poHeader => {
			const newRow = {
				...poHeader,
				ioNumber: poHeader.poCode.trim(),
				poCode: poHeader.poCode.trim(),
				isIONumberValid: 'Y',
				isIOUpdated: true,
				isDirty: true,
				seqId: Math.max(...updatedInvoiceDetails.map(r => r.seqId)) + 1,
				hasAuthority: poHeader.hasAuthority,
				allowInvoiceCorrection: invoiceState.invoiceDocument.allowInvoiceEditing == true ? 'Y' : 'N',
				tolerancePOFlag: poHeader.tolerancePOFlag,
				tolerancePOAmount: poHeader.tolerancePOAmount,
				taxCode: taxCode,
				clientCode: poHeader.clientCode,
				mediaType: poHeader.mediaType,
				isNew: true,
				hasPlacementAllocations: poHeader.hasPlacementAllocations || false,
				placementAllocations: poHeader.placementAllocations || []
			};
			if (poHeader.amount !== undefined) {
				newRow.amount = poHeader.amount;
			}

			if (taxCode) {
				calculateTaxAmount(taxCode, newRow); // Call calculateTaxAmount for the new row
			}
			updatedInvoiceDetails.push(newRow);
		});

		// Validate all rows
		const someValid = validateAllRows(updatedInvoiceDetails) || updatedInvoiceDetails.length === 0;
		setIsGridDataValid(someValid);
		setTaxCodeChange(false);
		if (stateUpliftMethods && stateUpliftMethods.setParentState) {
			stateUpliftMethods.setParentState({ isDirty: true });
		}
		setInvoiceState((prev) => ({
			...prev,
			isDirty: true,
			invoiceDocument: { ...invoiceDocument, invoiceDocumentEditorDetails: updatedInvoiceDetails }
		}))
	}, [invoiceState.invoiceDocument, stateUpliftMethods]);
	//#endregion

	//#endregion Initializers

	//#region Events

	const isBroadcastTaxGroupValid = (taxCode, taxes) => {
		if (!taxCode) return true;
		const groupTaxes = (taxes || []).filter(tax => tax.taxCode === taxCode);
		return groupTaxes.length > 0 &&
			groupTaxes.every(tax => (tax.taxType ?? tax.TaxType) != null) &&
			groupTaxes.some(tax => Number(tax.taxType ?? tax.TaxType) === 1);
	};

	const onTaxCodeChange = (event) => {
		if (props.info.modelDefId === 3 && event.currentTarget.value &&
			!isBroadcastTaxGroupValid(event.currentTarget.value, invoiceState?.taxes)) {
			toast.error('Broadcast tax group must have State or Local classification for every tax and include at least one State Tax.');
			return false;
		}

		let row = event.row;
		row.isTaxManuallyChanged = false;
		row.taxCode = event.currentTarget.value;
		calculateTaxAmount(row.taxCode, row);
		return true;
	}
	const onIoInvoiceAmountBlur = (event, row) => {
		calculateTaxAmount(row.taxCode, row);
		setState((prev) => ({ ...prev, forceRender: true }));
	}


	//#endregion Events

	//#region GridEvents

	const searchIONumber_clickHandler = (event, rowProp) => {
		setCurrentEditRow(rowProp);
		setTaxCodeChange(true);
		const selectedRow = invoiceState.invoiceDocument.invoiceDocumentEditorDetails.filter(row => selectedRows.has(row.seqId));
		let SelectedDataRows = selectedRow.length === 0 ? [rowProp] : selectedRow;
		// When placement-level matching is enabled each IO lookup is always a
		// multi-select session so the lookup opens in the split/placement-capable
		// flow regardless of how many grid lines are currently highlighted.
		stateUpliftMethods.searchIONumber_clickHandler(event, SelectedDataRows, rowProp);
	};

	const searchLevel2_clickHandler = (event, rowProp) => {
		setCurrentEditRow(rowProp);
		//currentEditRow = rowProp.row;
		const selectedLineStatuses =
			selectedRows.size > 0
				? invoiceState.invoiceDocument.invoiceDocumentEditorDetails
					.filter(row => selectedRows.has(row.seqId))
					.map(row => row.lineStatus)
				: [rowProp.lineStatus];
		setState((prev) => ({
			...prev, openLevel2Dialog: true, level2SelectionContext: {
				lineStatuses: selectedLineStatuses
			}
		}));
	}
	const searchLevel3_clickHandler = (event, rowProp) => {
		setCurrentEditRow(rowProp);
		setState((prev) => ({ ...prev, openLevel3Dialog: true }));
	}
	const searchCostCodes_clickHandler = (event, rowProp) => {
		setCurrentEditRow(rowProp);
		setState((prev) => ({ ...prev, openCostCodesDialog: true }));
	}

	const isRowLocked = (row) => {
		if (!row) return false;

		const invoiceStatus = Number(
			props?.originalInvoiceDocumentStatus
		);
		const lineStatus = Number(row.lineStatus);

		// When invoice is in Make Corrections (40),
		// approved lines must be locked
		if (
			invoiceStatus === 40 &&
			!isNaN(lineStatus) &&
			lineStatus >= 70 &&
			lineStatus !== 100
		) {
			return true;
		}

		if (row.hasAuthority === 'N' && lineStatus >= 50 && !overRideAllChecks) {
			return true;
		}

		return false;
	};


	const level2Dialog_closeHandler = (event, level2) => {

		if (!level2) {
			for (let id of [currentEditRow.seqId, ...selectedRows]) {
				let index = invoiceState.invoiceDocument?.invoiceDocumentEditorDetails.findIndex((e) => e.seqId == id);
				let row = invoiceState.invoiceDocument?.invoiceDocumentEditorDetails[index];

				if (row) {
					row.level2Key = null;
					row.isLevel2KeyValid = 'N';

					row.level3Key = null;
					row.isLevel3KeyValid = 'N';

					row.costType = null;
					row.resType = null;
					row.rTypeName = null;
					row.netCost = 0.00;
					row.matchToDateNet = 0.00;
					row.remainingAmount = 0.00;

					row.isDirty = true;
				}
			}

			setInvoiceState(prev => ({ ...prev, isDirty: true }));
			setState(prev => ({ ...prev, isDirty: true, openLevel2Dialog: false }));
			return;
		}

		for (let id of [currentEditRow.seqId, ...selectedRows]) {
			let index = invoiceState.invoiceDocument?.invoiceDocumentEditorDetails.findIndex((e) => e.seqId == id);
			let row = invoiceState.invoiceDocument?.invoiceDocumentEditorDetails[index];

			if (row) {
				if (row.level2Key !== level2.level2Key) {
					row.level3Key = null;
					row.costType = null;
					row.resType = null;
					row.rTypeName = null;
					row.netCost = 0.00;
					row.matchToDateNet = 0.00;
					row.remainingAmount = 0.00;
					row.isDirty = true;
					fetchLevel3(level2.level2Key, row);
				}

				row.level2Key = level2.level2Key;
				row.isLevel2KeyValid = 'Y';
				row.hasAuthority = level2.hasAuthority;
				row.poRequiredFlag = level2.poRequiredFlag;
				row.tolerancePOFlag = level2.tolerancePOFlag;
				row.tolerancePOAmount = level2.tolerancePOAmount;
			}
		}
		setLevel3RefreshKey(prev => prev + 1);

		setInvoiceState(prev => ({ ...prev, isDirty: true }));
		setState(prev => ({ ...prev, isDirty: true, openLevel2Dialog: false, clientLookup: [] }));
	};

	const clearLevel2Handler = (row) => {
		if (!row || row.seqId == null) return;

		const details = [...invoiceState.invoiceDocument.invoiceDocumentEditorDetails];
		const target = details.find(d => d.seqId === row.seqId);
		if (!target) return;

		target.level2Key = null;
		target.isLevel2KeyValid = 'N';

		target.level3Key = null;
		target.isLevel3KeyValid = 'N';

		target.costType = null;
		target.resType = null;
		target.rTypeName = null;
		target.lineStatus = 40;

		target.netCost = 0.00;
		target.matchToDateNet = 0.00;
		target.remainingAmount = 0.00;

		target.isDirty = true;

		setInvoiceState(prev => ({
			...prev,
			isDirty: true,
			invoiceDocument: {
				...prev.invoiceDocument,
				invoiceDocumentEditorDetails: details
			}
		}));

		validateAllRows(details);
	};

	const clearIONumberHandler = (row) => {
		if (!row || row.seqId == null) return;

		const details = [...invoiceState.invoiceDocument.invoiceDocumentEditorDetails];
		const target = details.find(d => d.seqId === row.seqId);
		if (!target) return;

		const previousIoNumber = target.ioNumber;
		target.ioNumber = "";
		target.poCode = "";
		//target.ioDescription = null;
		target.isIONumberValid = 'N';
		target.siteName = null;
		target.siteId = null;
		target.lineStatus = 40;
		target.clientCode = null;

		target.poAmount = 0.00;
		target.consumedAmount = 0.00;
		target.deliveryAmount = 0.00;

		const previousPlacements = target.placements || [];
		if (!target.isNew) {
			const existingDeletedPlacements = target.deletedPlacements || [];
			const deletedPlacementKeys = new Set(existingDeletedPlacements.map(p => String(p.placementId ?? p.placementCode ?? '')));
			target.deletedPlacements = [
				...existingDeletedPlacements,
				...previousPlacements
					.filter(p => !deletedPlacementKeys.has(String(p.placementId ?? p.placementCode ?? '')))
					.map(p => ({ ...p, seqId: target.seqId, ioNumber: previousIoNumber }))
			];
		}
		target.placements = [];
		target.hasPlacementAllocations = false;
		target.placementAllocations = [];

		// Recalculate tax based on the now-zero ioInvoiceAmount so the tax field
		// doesn't retain its stale value after the IO is removed.
		// if (target.taxCode) {
		// 	calculateTaxAmount(target.taxCode, target);
		// }

		target.isDirty = true;

		setInvoiceState(prev => ({
			...prev,
			isDirty: true,
			invoiceDocument: {
				...prev.invoiceDocument,
				invoiceDocumentEditorDetails: details
			}
		}));

		validateAllRows(details);
	};

	const canShowClearIcon = (row) => {
		if (!row) return false;

		const { companyApprovalConfiguration } = invoiceState.invoiceDocument || {};
		const routingNumberOfApprovalLevels = companyApprovalConfiguration?.routingNumberOfApprovalLevels || 0;
		const invoiceDocumentStatusId = Number(row.lineStatus);

		if (isApprovalLevelBreached({
			routingNumberOfApprovalLevels,
			invoiceDocumentStatusId
		})) {
			return false;
		}

		return true;
	};

	const level3Dialog_closeHandler = React.useCallback((event, level3) => {

		if (!level3) {
			for (let id of [currentEditRow.seqId, ...selectedRows]) {
				let index = invoiceState.invoiceDocument?.invoiceDocumentEditorDetails.findIndex((e) => e.seqId == id);
				let row = invoiceState.invoiceDocument?.invoiceDocumentEditorDetails[index];

				if (row) {
					row.level3Key = null;
					row.isLevel3KeyValid = 'N';

					row.costType = null;
					row.resType = null;
					row.rTypeName = null;
					row.netCost = 0.00;
					row.matchToDateNet = 0.00;
					row.remainingAmount = 0.00;

					row.isDirty = true;
				}
			}

			setInvoiceState(prev => ({ ...prev, isDirty: true }));
			setState(prev => ({ ...prev, openLevel3Dialog: false }));
			return;
		}

		for (let id of [currentEditRow.seqId, ...selectedRows]) {
			let index = invoiceState.invoiceDocument?.invoiceDocumentEditorDetails.findIndex((e) => e.seqId == id);
			let row = invoiceState.invoiceDocument?.invoiceDocumentEditorDetails[index];

			if (row.level3Key !== level3.level3Key) {
				row.resType = null;
				row.rTypeName = null;
				row.netCost = 0.00;
				row.matchToDateNet = 0.00;
				row.remainingAmount = 0.00;
				row.isDirty = true;
			}

			row.level3Key = level3.level3Key;
			row.costType = level3.costType;
			row.isLevel3KeyValid = 'Y';

			fetchCostCodes(level3.level2Key, level3.level3Key, row);
		}

		setInvoiceState(prev => ({ ...prev, isDirty: true }));
		setState(prev => ({ ...prev, openLevel3Dialog: false }));

	}, [currentEditRow, selectedRows]);

	const costCodesDialog_closeHandler = (event, costCodes) => {
		if (costCodes) {
			for (let id of [currentEditRow.seqId, ...selectedRows]) {
				let index = invoiceState.invoiceDocument?.invoiceDocumentEditorDetails.findIndex((e) => e.seqId == id);
				let row = invoiceState.invoiceDocument?.invoiceDocumentEditorDetails[index]
				row.resType = costCodes.resType;
				row.rTypeName = costCodes.rTypeName;
				row.isCostCodesValid = 'Y';
				row.netCost = costCodes.netCost;
				row.matchToDateNet = costCodes.matchToDateNet;
				row.remainingAmount = costCodes.remainingAmount;
				row.isDirty = true;
			}

		}
		setInvoiceState((prev) => ({
			...prev, isDirty: true
		}))
		setState((prev) => ({ ...prev, openCostCodesDialog: false }));
	}
	const getRefreshButton = () => {
		if (isPartialPostMode) return null;
		const isMedia = invoiceState.invoiceDocument.modelDefId === 1;
		const isProduction = invoiceState.invoiceDocument.modelDefId === 2;

		const noIoForMedia = isMedia && !invoiceState.invoiceDocument.invoiceDocumentEditorDetails.some(d => !stringIsNullOrEmpty(d.ioNumber));
		const noPoForProduction = isProduction && stringIsNullOrEmpty(invoiceState.invoiceDocument?.poCode);

		const isDisabled = props.readOnly || noIoForMedia || noPoForProduction;

		return (
			<IconButton
				id="refresh-lines-button"
				key={3}
				variant="contained"
				onClick={refresh_clickHandler}
				size="small"
				style={{ float: "right", zIndex: 1, marginTop: 2 }}
				disabled={isDisabled}
			>
				<Tooltip key={1} title={'Refresh'}>
					<RefreshIcon key={2} />
				</Tooltip>
			</IconButton>
		);
	};
	const refresh_clickHandler = (event) => {
		var invoiceDocument = invoiceState.invoiceDocument;
		if (props.info.modelDefId === 1) {
			const ioNumbers = invoiceDocument.invoiceDocumentEditorDetails.map(item => item.ioNumber);
			const distinctIoNumbers = [...new Set(ioNumbers)];
			distinctIoNumbers.map(function (ioNumber) {
				if (!stringIsNullOrEmpty(ioNumber)) {
					getUpdatedData(null, ioNumber);
				}
			});
		}
		else if (props.info.modelDefId === 2 && !stringIsNullOrEmpty(props.poCode)) {
			getUpdatedData(null, props.poCode);
		}
		setInvoiceState((prev) => ({
			...prev, isDirty: true
		}))
	}

	// custom grid buttons 
	const getAddButton = React.useCallback(() => {
		if (isPartialPostMode) return null;
		const isEditDatesMode = editorMode === Constants.EDIT_DATES;
		const isReadOnlyState = isEditDatesMode || isFieldReadOnly("Add Line");
		return <IconButton
			id="add-line-button"
			key={1}
			variant="contained"
			onClick={isReadOnlyState ? null : handleAddClick}
			disabled={isReadOnlyState}
			size="small"
			style={{ float: "right", zIndex: 1, marginTop: 2 }}
		>
			<Tooltip key={1} title={'Add'} >
				<AddBoxIcon key={2} />
			</Tooltip>

		</IconButton>;
	});
	const getDeleteButton = React.useCallback(() => {
		if (isPartialPostMode) return null;
		const isReadOnlyState = (selectedRows.size === 0) ? true : isFieldReadOnly("Delete Line");

		return <IconButton
			id="delete-line-button"
			key={2}
			variant="contained"
			color="inherit"
			onClick={isReadOnlyState ? null : handleDeleteSelectedClick}
			size="small"
			disabled={(selectedRows.size === 0) ? true : isFieldReadOnly("Delete Line")}
			style={{ float: "right", zIndex: 1, marginTop: 2 }}
		>
			<Tooltip key={1} title={'Delete'}>
				<DeleteIcon key={2} />
			</Tooltip>

		</IconButton>;
	});
	const getMergeButton = React.useCallback(() => {
		if (isPartialPostMode) return null;
		if (invoiceState.invoiceDocument.modelDefId === 2) {
			return null;
		}
		const isReadOnlyState = isMergeButtonDisabled ? true : isFieldReadOnly("Merge Line")
		return (
			<IconButton
				id="merge-lines-button"
				key="merge"
				variant="contained"
				onClick={isReadOnlyState ? null : handleMergeClick}
				disabled={isMergeButtonDisabled ? true : isFieldReadOnly("Merge Line")}
				size="small"
				style={{ float: "right", zIndex: 1, marginTop: 4, transform: "rotate(90deg)" }}
			>
				<Tooltip key="merge-tooltip" title={'Merge Line(s)'}>
					<MergeIcon key="merge-icon" />
				</Tooltip>
			</IconButton>
		);
	}, [invoiceState.invoiceDocument.modelDefId, isMergeButtonDisabled, invoiceState.invoiceDocument.invoiceDocumentEditorDetails, selectedRows]);
	const getSplitButton = React.useCallback(() => {
		if (isPartialPostMode) return null;
		if (invoiceState.invoiceDocument.modelDefId === 2) {
			return null;
		}
		if (invoiceState.invoiceDocument.insertionLevelMatchingCriteria === 1) {
			return null;
		}
		const isReadOnlyState = isSearchButtonDisabled ? true : isFieldReadOnly("Split Line");
		return (
			<IconButton
				id="split-lines-button"
				key={1}
				variant="contained"
				onClick={isReadOnlyState ? null : handleSplitClick}
				disabled={isSearchButtonDisabled ? true : isFieldReadOnly("Split Line")}
				size="small"
				style={{ float: "right", zIndex: 1, marginTop: 4 }}
			>
				<Tooltip key={1} title={'Split Line'} >
					<CallSplitIcon key={2} />
				</Tooltip>

			</IconButton>
		);
	}, [invoiceState.invoiceDocument.modelDefId, isSearchButtonDisabled, invoiceState.invoiceDocument.invoiceDocumentEditorDetails, selectedRows]);
	const getApproveButton = React.useCallback(() => {
		if (isPartialPostMode) return null;
		const hasApprovableLine = invoiceState.invoiceDocument?.invoiceDocumentEditorDetails?.some(row => row.hasAuthority === 'Y' && row.lineStatus >= 50) || false;
		if (
			props.originalInvoiceDocumentStatus < 50 ||
			props.originalInvoiceDocumentStatus === 60
		) {
			return null;
		}

		if (!hasApprovableLine) {
			return null;
		}
		let filterStyleForButton = ''
		if (isApproveButtonDisabled) {
			filterStyleForButton += ' opacity(0.5)'
		}

		return (
			<IconButton
				id="approve-lines-button"
				key="approve"
				variant="contained"
				onClick={handleApproveLineClick}
				disabled={isApproveButtonDisabled}
				size="small"
				style={{ float: "right", zIndex: 1, marginTop: 4 }}
			>
				<Tooltip key="approve-tooltip" title={'Approve Line(s)'}>
					<img key="approve-icon" src="/images/timesheetApproved.png" alt="Approve Icon" style={{ width: 20, height: 20, filter: filterStyleForButton }} />
				</Tooltip>
			</IconButton>
		);
	}, [selectedRows, props.originalInvoiceDocumentStatus, invoiceState.invoiceDocument.invoiceDocumentEditorDetails, isApproveButtonDisabled]);

	const getRejectButton = React.useCallback(() => {
		if (isPartialPostMode) return null;
		const hasApprovableLine = invoiceState.invoiceDocument?.invoiceDocumentEditorDetails?.some(row => row.hasAuthority === 'Y' && row.lineStatus >= 50) || false;
		if (
			props.originalInvoiceDocumentStatus < 50 ||
			props.originalInvoiceDocumentStatus === 60
		) {
			return null;
		}

		if (!hasApprovableLine) {
			return null;
		}
		let filterStyleForButton = ''
		if (isRejectButtonDisabled) {
			filterStyleForButton += ' opacity(0.5)'
		}

		return (
			<IconButton
				id="reject-lines-button"
				key="reject"
				variant="contained"
				onClick={handleRejectLineClick}
				disabled={isRejectButtonDisabled}
				size="small"
				style={{ float: "right", zIndex: 1, marginTop: 4 }}
			>
				<Tooltip key="reject-tooltip" title={'Reject Line(s)'}>
					<img key="reject-icon" src="/images/timesheetRejected.png" alt="Reject Icon" style={{ width: 20, height: 20, filter: filterStyleForButton }} />
				</Tooltip>
			</IconButton>
		);
	}, [selectedRows, props.originalInvoiceDocumentStatus, invoiceState.invoiceDocument.invoiceDocumentEditorDetails, isRejectButtonDisabled]);
	// custom grid buttons

	const handleAddClick = React.useCallback(() => {
		const invoiceDocumentDetails = invoiceState.invoiceDocument?.invoiceDocumentEditorDetails;
		const id = ([...invoiceDocumentDetails]?.sort((a, b) => b.seqId - a.seqId)[0]?.seqId + 1) || 1;
		let model = invoiceEditorDetailModel();
		model.seqId = id;
		model.isNew = true;
		model.companyCode = invoiceState.invoiceDocument?.companyCode;
		model.invoiceDocumentId = invoiceState.invoiceDocument?.invoiceDocumentId;
		model.lineStatus = 50;
		model.hasAuthority = 'Y';
		model.allowInvoiceEditing = invoiceState.invoiceDocument?.allowInvoiceEditing;
		model.clientCode = stringIsNullOrEmpty(invoiceState.invoiceDocument?.clientCode)
			? null
			: invoiceState.invoiceDocument?.clientCode;
		const details = invoiceState.invoiceDocument?.invoiceDocumentEditorDetails || [];

		if (details.length > 0) {

			const readOnlyRow = invoiceState.readOnly;

			const editableLines = details.filter(detail => {
				const lineStatus = Number(detail.lineStatus);

				const baseEditable =
					(detail.hasAuthority === 'Y' && detail.allowInvoiceCorrection === 'Y') ||
					lineStatus <= 50 ||
					lineStatus === 180;

				return !readOnlyRow && baseEditable;
			});

			if (editableLines.length > 0) {
				const uniqueTaxCodes = new Set(editableLines.map(d => d?.taxCode || ''));

				if (uniqueTaxCodes.size === 1) {
					model.taxCode = Array.from(uniqueTaxCodes)[0] || '';
				}
			}
		}

		setInvoiceState((prev) => ({
			...prev, isDirty: true, invoiceDocument: { ...prev.invoiceDocument, invoiceDocumentEditorDetails: [...prev.invoiceDocument.invoiceDocumentEditorDetails, model] }
		}))
		setState((prev) => ({
			...prev,
			addClickUpdate: true
		}));
	});
	const handleDeleteSelectedClick = React.useCallback(() => {
		setState((prev) => ({ ...prev, taxCodeChange: true, openDeleteSelectedConfirmation: true }));
	});

	const handleApproveLineClick = React.useCallback(() => {
		const selectedRowsData = invoiceState.invoiceDocument.invoiceDocumentEditorDetails.filter(row => selectedRows.has(row.seqId));
		if (selectedRowsData.length === 0) return;
		const hasAuthority = selectedRowsData.every(row => row.hasAuthority === 'Y');
		const hasPO = selectedRowsData.some(row => row.poCode === null);

		if (hasPO && invoiceState.invoiceDocument.modelDefId == 1) {
			toast.error('Please select IO/PO for approval.');
			return;
		}
		if (invoiceState.invoiceDocument.modelDefId == 2) {
			const hasAllRequiredFields = selectedRowsData.every(row =>
				row.level2Key && row.level3Key && row.rTypeName
			);

			if (!hasAllRequiredFields) {
				toast.error('Please ensure all required fields are filled for the selected line(s).');
				return;
			}
		}
		if (!hasAuthority) {
			toast.error('You are not authorize to approve the selected line(s).');
			return;
		}
		const linesToApprove = selectedRowsData.filter(row => row.statusDescription !== 'Approved');
		if (linesToApprove.length === 0) {
			return;
		}

		const allowComment =
			companyApprovalConfiguration?.allowInvoiceApprovalCommentFlag !== 'N';
		if (!allowComment) {
			updateInvoiceDocument(selectedRowsData, 'approve', '');
			toast.info('Approval status updated. Click “Save” to apply changes.');
			return;
		}

		setActionType('approve');
		let nextLevelDescs = selectedRowsData.map(row => row.nextLevelApprovalDescription).join(', ');
		if (nextLevelDescs.includes('Ready') && invoiceState.invoiceDocument.modelDefId == 1)
			nextLevelDescs = 'Media Approval';
		else
			nextLevelDescs = 'Approval';
		setnextleveldesc(nextLevelDescs);
		setComment(selectedRows.size === 1 ? selectedRowsData[0].LineComments : '');
		setOpenCommentDialog(true);
	}, [selectedRows, invoiceState.invoiceDocument.invoiceDocumentEditorDetails, invoiceState.invoiceDocument.companyApprovalConfiguration]);

	const handleRejectLineClick = React.useCallback(() => {
		const selectedRowsData = invoiceState.invoiceDocument.invoiceDocumentEditorDetails.filter(row => selectedRows.has(row.seqId));

		const hasAuthority = selectedRowsData.every(row => row.hasAuthority === 'Y');
		const hasPO = selectedRowsData.some(row => row.poCode === null);

		if (hasPO && invoiceState.invoiceDocument.modelDefId == 1) {
			toast.error('Please select IO/PO for approval.');
			return;
		}
		if (invoiceState.invoiceDocument.modelDefId == 2) {
			const hasAllRequiredFields = selectedRowsData.every(row =>
				row.level2Key && row.level3Key && row.rTypeName
			);

			if (!hasAllRequiredFields) {
				toast.error('Please ensure all required fields are filled for the selected line(s).');
				return;
			}
		}

		if (!hasAuthority) {
			toast.error('You are not authorize to reject the selected line(s).');
			return;
		}

		setActionType('reject');
		let nextLevelDescs = selectedRowsData.map(row => row.nextLevelApprovalDescription).join(', ');
		nextLevelDescs = 'Rejection';
		setnextleveldesc(nextLevelDescs);
		setComment(selectedRows.size === 1 ? selectedRowsData[0].LineComments : '');
		setOpenCommentDialog(true);
	}, [selectedRows, invoiceState.invoiceDocument.invoiceDocumentEditorDetails]);

	const handleCommentDialogSave = () => {
		if (actionType === 'reject' && stringIsNullOrEmpty(comment.trim())) {
			toast.error('Comments are required for rejection.');
			return;
		}

		const selectedRowsData = invoiceState.invoiceDocument.invoiceDocumentEditorDetails.filter(row => selectedRows.has(row.seqId));
		updateInvoiceDocument(selectedRowsData, actionType, comment);
		setOpenCommentDialog(false);
		setComment('');
	};

	const updateInvoiceDocument = (selectedRowsData, actionType, comment) => {
		let statuses = invoiceState.invoiceDocument?.companyApprovalConfiguration;
		const updatedInvoiceDetails = invoiceState.invoiceDocument.invoiceDocumentEditorDetails.map(row => {
			if (selectedRows.has(row.seqId)) {
				let currentStatus = row.lineStatus;
				let key = '';
				if (currentStatus === 50 && actionType === 'approve') {
					key = 'approvalLevel1AcceptName'
				} else {
					if (actionType === 'approve') {
						key = `approvalLevel${((currentStatus + 20) - 50) / 20}AcceptName`
					} else {
						key = `approvalLevel${((currentStatus + 20) - 50) / 20}RejectName`
					}
				}

				return {
					...row,
					statusDescription: actionType === 'approve' ? 'Approved' : 'Rejected',
					LineComments: comment,
					nextLevelApprovalDescription: statuses && statuses[key] ? statuses[key] : actionType === 'approve' ? 'Approved' : 'Rejected',
					isDirty: true
				};
			}
			return row;
		});
		setInvoiceState(prev => ({
			...prev, isDirty: true,
			invoiceDocument: {
				...prev.invoiceDocument,
				invoiceDocumentEditorDetails: updatedInvoiceDetails
			}
		}));

	};
	//custom grid buttons events

	const closeDeleteDialog = React.useCallback((event) => {
		setState((prev) => ({ ...prev, openDeleteConfirmation: false, deleteRowData: null }));
	})
	const closeDeleteSelectedDialog = React.useCallback((event) => {
		setState((prev) => ({ ...prev, taxCodeChange: false, openDeleteSelectedConfirmation: false }));
	})
	const getDeletedDetailWithPlacements = (detail) => {
		if (!detail || detail.isNew) return detail;

		const existingDeletedPlacements = detail.deletedPlacements || [];
		const deletedPlacementKeys = new Set(existingDeletedPlacements.map(placement => String(placement.placementId ?? placement.placementCode ?? '')));
		const deletedPlacements = [
			...existingDeletedPlacements,
			...(detail.placements || [])
				.filter(placement => !deletedPlacementKeys.has(String(placement.placementId ?? placement.placementCode ?? '')))
				.map(placement => ({ ...placement, seqId: detail.seqId, ioNumber: detail.ioNumber }))
		];

		return { ...detail, deletedPlacements };
	};
	const getDeletedDetailTaxes = (detail) =>
		(detail?.invoiceDocumentDetailTaxes || []).map(tax => ({
			...tax,
			seqId: detail.seqId
		}));

	const deleteRecord = React.useCallback(() => {
		let data = state.deleteRowData;
		setSelectedRows(new Set([...selectedRows].filter((e, i) => e !== data.seqId)))
		// Track lines that originated from the database (not newly added and then deleted) so the
		// server can delete only these specific lines instead of deleting/re-inserting everything.
		const existingDeletedDetails = invoiceState.invoiceDocument.deletedInvoiceDocumentEditorDetails || [];
		const newlyDeletedDetails = !data.isNew ? [...existingDeletedDetails, getDeletedDetailWithPlacements(data)] : existingDeletedDetails;
		const existingDeletedTaxes = invoiceState.invoiceDocument.deletedInvoiceDocumentDetailTaxes || [];
		const newlyDeletedTaxes = !data.isNew
			? [...existingDeletedTaxes, ...getDeletedDetailTaxes(data)]
			: existingDeletedTaxes;
		setInvoiceState(prev => ({
			...prev, isDirty: true,
			invoiceDocument: {
				...prev.invoiceDocument,
				invoiceDocumentEditorDetails: invoiceState.invoiceDocument.invoiceDocumentEditorDetails.filter((e, i) => e.seqId !== data.seqId),
				deletedInvoiceDocumentEditorDetails: newlyDeletedDetails,
				deletedInvoiceDocumentDetailTaxes: newlyDeletedTaxes
			}
		}));
		setState((prev) => ({
			...prev, openDeleteConfirmation: false, deleteRowData: null, deleteClickUpdate: true
		}));
	})

	const deleteSelectedRecord = React.useCallback(() => {
		setTaxCodeChange(false);
		const updatedInvoiceDocumentEditorDetails = invoiceState.invoiceDocument.invoiceDocumentEditorDetails.filter(
			(detail) => !selectedRows.has(detail.seqId)
		);

		// Track lines that originated from the database (not newly added and then deleted) so the
		// server can delete only these specific lines instead of deleting/re-inserting everything.
		const removedDbDetails = invoiceState.invoiceDocument.invoiceDocumentEditorDetails.filter(
			(detail) => selectedRows.has(detail.seqId) && !detail.isNew
		).map(getDeletedDetailWithPlacements);
		const existingDeletedDetails = invoiceState.invoiceDocument.deletedInvoiceDocumentEditorDetails || [];
		const newlyDeletedDetails = removedDbDetails.length > 0 ? [...existingDeletedDetails, ...removedDbDetails] : existingDeletedDetails;
		const existingDeletedTaxes = invoiceState.invoiceDocument.deletedInvoiceDocumentDetailTaxes || [];
		const newlyDeletedTaxes = removedDbDetails.length > 0
			? [...existingDeletedTaxes, ...removedDbDetails.flatMap(getDeletedDetailTaxes)]
			: existingDeletedTaxes;

		let newClientCode = null;
		if (updatedInvoiceDocumentEditorDetails.length > 0) {
			const remainingClientCodes = updatedInvoiceDocumentEditorDetails
				.map((detail) => detail.clientCode)
				.filter((code) => code !== null);

			if (remainingClientCodes.every((code) => code === remainingClientCodes[0])) {
				newClientCode = remainingClientCodes[0];
			}
		}
		setInvoiceState(prev => ({
			...prev, isDirty: true,
			invoiceDocument: {
				...prev.invoiceDocument,
				invoiceDocumentEditorDetails: updatedInvoiceDocumentEditorDetails,
				deletedInvoiceDocumentEditorDetails: newlyDeletedDetails,
				deletedInvoiceDocumentDetailTaxes: newlyDeletedTaxes,
				clientCode: newClientCode
			}
		}));

		setState((prev) => ({
			...prev,
			openDeleteSelectedConfirmation: false,
			taxCodeChange: false,
			deleteRowData: null,
			deleteClickUpdate: true
		}));

		setSelectedRows(new Set());

		const matchesDisplayedClientCode =
			newClientCode == null || updatedInvoiceDocumentEditorDetails.every((detail) => detail.clientCode === newClientCode);

		props.onClientCodeConsistencyChange(matchesDisplayedClientCode);
	}, [invoiceState.invoiceDocument, selectedRows, props.onClientCodeConsistencyChange]);


	const handleMergeClick = () => {
		const selectedRowsData = invoiceState.invoiceDocument.invoiceDocumentEditorDetails.filter(row => selectedRows.has(row.seqId));
		const uniquePONumbers = new Set(selectedRowsData.map(row => row.poCode));
		const uniqueTaxCode = new Set(selectedRowsData.map(row => row.taxCode));
		const hasInvalidLineStatus = selectedRowsData.some(row => row.lineStatus > 60 && row.lineStatus !== 100);

		if (uniqueTaxCode.size !== 1) {
			toast.error('Selected rows have different tax codes and cannot be merged.');
			return;
		}

		if (hasInvalidLineStatus) {
			toast.error('Approved lines at any level cannot be merged');
			return;
		}

		if (uniquePONumbers.size === 1 || (uniquePONumbers.size === 2 && uniquePONumbers.has(null))) {
			const firstSelectedRow = selectedRowsData.find(row => row.poCode !== null) || selectedRowsData[0];
			let totalIoInvoiceAmount = 0;
			let totalTaxAmount = 0;
			let unionedPlacements = [];

			selectedRowsData.forEach(row => {
				if (row.ioInvoiceAmount) {
					totalIoInvoiceAmount += parseFloat(row.ioInvoiceAmount) || 0;
				}
				if (row.taxAmount) {
					totalTaxAmount += parseFloat(row.taxAmount) || 0;
				}

				const rowMode = (row.ioSessionMode || invoiceState.invoiceDocument?.ioSessionMode || 'io').toString().trim().toLowerCase();
				if (invoiceState.invoiceDocument.insertionLevelMatchingCriteria === 1 && rowMode === 'placement' && row.placements) {
					row.placements.forEach(p => {
						const existing = unionedPlacements.find(up => up.placementId === p.placementId);
						const transferredToExistingRow = !firstSelectedRow.isNew && row.seqId !== firstSelectedRow.seqId;
						if (!existing) {
							unionedPlacements.push({
								...p,
								...(transferredToExistingRow ? { isDirty: true, isNew: false } : {})
							});
						} else {
							existing.allocAmount = (parseFloat(existing.allocAmount) || 0) + (parseFloat(p.allocAmount) || 0);
							if (transferredToExistingRow) {
								existing.isDirty = true;
								existing.isNew = false;
							}
						}
					});
				}
			});

			const updatedFirstSelectedRow = {
				...firstSelectedRow,
				ioInvoiceAmount: totalIoInvoiceAmount.toFixed(2),
				taxAmount: totalTaxAmount.toFixed(2),
				isDirty: !firstSelectedRow.isNew
			};

			if (invoiceState.invoiceDocument.insertionLevelMatchingCriteria === 1) {
				const firstRowMode = (firstSelectedRow.ioSessionMode || invoiceState.invoiceDocument?.ioSessionMode || 'io').toString().trim().toLowerCase();
				updatedFirstSelectedRow.placements = firstRowMode === 'placement' ? unionedPlacements : [];
			}

			calculateTaxAmount(firstSelectedRow.taxCode, updatedFirstSelectedRow);

			const updatedInvoiceDetails = invoiceState.invoiceDocument.invoiceDocumentEditorDetails.map(row => {
				if (selectedRows.has(row.seqId)) {
					if (row.seqId === firstSelectedRow.seqId) {
						return updatedFirstSelectedRow;
					}
					return null;
				}
				return row;
			}).filter(Boolean);
			const mergedAwayRows = selectedRowsData.filter(row => row.seqId !== firstSelectedRow.seqId && !row.isNew);
			const existingDeletedDetails = invoiceState.invoiceDocument.deletedInvoiceDocumentEditorDetails || [];
			const existingDeletedTaxes = invoiceState.invoiceDocument.deletedInvoiceDocumentDetailTaxes || [];
			const mergedDeletedDetails = mergedAwayRows.map(getDeletedDetailWithPlacements);
			const mergedDeletedTaxes = mergedAwayRows.flatMap(getDeletedDetailTaxes);
			setSelectedRows(new Set());
			validateAllRows(updatedInvoiceDetails);
			const totalRowsAfterMerge = updatedInvoiceDetails.length;
			const newPage = Math.min(Math.floor(totalRowsAfterMerge / pageSize), page);

			setPage(newPage);

			setInvoiceState(prev => ({
				...prev, isDirty: true,
				invoiceDocument: {
					...prev.invoiceDocument,
					invoiceDocumentEditorDetails: updatedInvoiceDetails,
					deletedInvoiceDocumentEditorDetails: [
						...existingDeletedDetails,
						...mergedDeletedDetails
					],
					deletedInvoiceDocumentDetailTaxes: [
						...existingDeletedTaxes,
						...mergedDeletedTaxes
					]
				}
			}));
			toast.success('Lines merged successfully');
		} else {
			toast.error('Selected rows must have the same PO number to merge.');
		}
	};
	const handleSplitClick = () => {
		const selectedRowsData = invoiceState.invoiceDocument.invoiceDocumentEditorDetails.filter(row => selectedRows.has(row.seqId));
		const hasInvalidLineAmount = Array.from(selectedRowsData).some(row =>
			row.ioInvoiceAmount === 0 || row.ioInvoiceAmount === "0" || row.ioInvoiceAmount === "0.00" || row.ioInvoiceAmount === null
		);
		if (hasInvalidLineAmount) {
			toast.error('Line Amount Zero cannot be splitted');
			return;
		}
		stateUpliftMethods.searchIONumber_clickHandler(event, selectedRowsData, null, true);
	}
	//#endregion GridEvents

	//#region Validations
	const groupAndSum = (arr, groupKeys, sumKeys) => {
		return Object.values(
			arr.reduce((acc, curr) => {
				const group = groupKeys.map(k => curr[k]).join('-');
				acc[group] = acc[group] || Object.fromEntries(groupKeys.map(k => [k, curr[k]]).concat(sumKeys.map(k => [k, 0])));
				sumKeys.forEach(k => acc[group][k] += parseFloat(curr[k]));
				return acc;
			}, {})
		);
	}
	const POCodeNotEmptyAndValid = () => {
		return (!stringIsNullOrEmpty(props.poCode) && props?.invoiceDocument?.isPOCodeValid === 'Y')
	}
	const IONumberValid = (rowData) => {
		var isValid = true;
		if (invoiceState.invoiceDocument.modelDefId === 1 &&
			(stringIsNullOrEmpty(rowData.ioNumber) || (!stringIsNullOrEmpty(rowData.ioNumber) && rowData.isIONumberValid !== 'Y'))) {
			isValid = false;
		}
		return isValid;
	}
	const needsPlacementSelection = (rowData) => {
		const sessionMode = (rowData?.ioSessionMode || '').toString().trim().toLowerCase();
		return invoiceState.invoiceDocument.modelDefId === 1 &&
			sessionMode === 'placement' &&
			(!Array.isArray(rowData?.placements) || rowData.placements.length === 0);
	}
	const showIONumberWarning = (rowData) => !IONumberValid(rowData) || needsPlacementSelection(rowData);
	const Level2KeyValid = (rowData) => {
		var isValid = true;
		if (invoiceState.invoiceDocument.modelDefId === 2 &&
			(stringIsNullOrEmpty(rowData.level2Key) || (!stringIsNullOrEmpty(rowData.level2Key) && rowData.isLevel2KeyValid !== 'Y'))) {
			isValid = false;
		}
		return isValid;
	}
	const Level3KeyValid = (rowData) => {
		var isValid = true;
		if (invoiceState.invoiceDocument.modelDefId === 2 &&
			(stringIsNullOrEmpty(rowData.level3Key) || (!stringIsNullOrEmpty(rowData.level3Key) && rowData.isLevel3KeyValid !== 'Y'))) {
			isValid = false;
		}
		return isValid;
	}
	const CostCodesValid = (rowData) => {
		var isValid = true;
		if (invoiceState.invoiceDocument.modelDefId === 2 &&
			(stringIsNullOrEmpty(rowData.resType) || (!stringIsNullOrEmpty(rowData.resType) && rowData.isCostCodesValid !== 'Y'))) {
			isValid = false;
		}
		return isValid;
	}
	const TaxCodeValid = (newData) => {
		var isValid = true;
		const invoiceDocument = invoiceState.invoiceDocument;
		if (invoiceDocument && invoiceDocument.invoiceDocumentEditorDetails) {
			var IOPO = invoiceDocument.invoiceDocumentEditorDetails;
			var invoiceDocumentEditorDetails = IOPO.filter(x => x.ioNumber && x.ioNumber == newData.ioNumber && x.taxCode != newData.taxCode);
			if (invoiceDocumentEditorDetails && invoiceDocumentEditorDetails.length > 0) {
				isValid = false;
			}
		}
		return isValid;
	}
	// updateTaxCode moved to context
	const InvoiceAmountValid = (rowData) => {
		var isValid = false;
		// -ve values are also acceptable in invoice details
		if (invoiceState.invoiceDocument.modelDefId === 2) {
			isValid = rowData.ioInvoiceAmount != 0;
			if (isValid) {
				if (!stringIsNullOrEmpty(invoiceState.invoiceDocument?.poCode)) {
					var invoiceDocumentEditorDetails = JSON.parse(JSON.stringify(invoiceState.invoiceDocument.invoiceDocumentEditorDetails));
					var index = invoiceDocumentEditorDetails.findIndex(d => d.seqId === rowData.seqId);
					if (index < 0) {
						invoiceDocumentEditorDetails.push(JSON.parse(JSON.stringify(rowData)));
					} else {
						invoiceDocumentEditorDetails[index] = JSON.parse(JSON.stringify(rowData));
					}
					invoiceDocumentEditorDetails[invoiceDocumentEditorDetails.findIndex(d => d.seqId === rowData.seqId)].ioInvoiceAmount = Number(Number(rowData.ioInvoiceAmount).toFixed(2));
					var groupedInvoiceDocumentDetails = groupAndSum(invoiceDocumentEditorDetails, ['level2Key', 'tolerancePOFlag', 'tolerancePOAmount', 'level3Key', 'resType', 'remainingAmount'], ['ioInvoiceAmount']);
					var groupedFilteredOnKeyFields = groupedInvoiceDocumentDetails.filter(d => d.level2Key === rowData.level2Key && d.level3Key === rowData.level3Key && d.resType === rowData.resType);
					isValid = !(groupedFilteredOnKeyFields.some(d => {
						var isInvoiceAmountInvalid = Number(zeroIfNull(parseFloat(d.ioInvoiceAmount || 0)).toFixed(2)) > Number(zeroIfNull(d.remainingAmount).toFixed(2));
						if (isInvoiceAmountInvalid) {
							if (d.tolerancePOFlag === 'N') {
								isInvoiceAmountInvalid = Number(zeroIfNull(parseFloat(d.ioInvoiceAmount || 0)).toFixed(2)) > Number((zeroIfNull(d.remainingAmount) + zeroIfNull(d.tolerancePOAmount)).toFixed(2));
							}
							else {
								var percentRemainingAmount = (zeroIfNull(d.tolerancePOAmount) * zeroIfNull(d.remainingAmount)) / 100.00;
								isInvoiceAmountInvalid = Number(Number(parseFloat(d.ioInvoiceAmount || 0)).toFixed(2)) > Number((d.remainingAmount + percentRemainingAmount).toFixed(2));
							}
						}
						return isInvoiceAmountInvalid;
					}));
				}
			}
		}
		else {
			isValid = rowData.ioInvoiceAmount != 0;
			if (isValid) {
				var invoiceDocumentEditorDetails = JSON.parse(JSON.stringify(invoiceState.invoiceDocument.invoiceDocumentEditorDetails));
				var index = invoiceDocumentEditorDetails.findIndex(d => d.seqId === rowData.seqId);
				if (index < 0) {
					invoiceDocumentEditorDetails.push(JSON.parse(JSON.stringify(rowData)));
				} else {
					invoiceDocumentEditorDetails[index] = JSON.parse(JSON.stringify(rowData));
				}
				invoiceDocumentEditorDetails[invoiceDocumentEditorDetails.findIndex(d => d.seqId === rowData.seqId)].ioInvoiceAmount = Number(Number(rowData.ioInvoiceAmount).toFixed(2));
				var groupedInvoiceDocumentDetails = groupAndSum(invoiceDocumentEditorDetails, ['ioNumber', 'poAmount', 'consumedAmount', 'tolerancePOFlag', 'tolerancePOAmount'], ['ioInvoiceAmount']);
				var groupedFilteredOnKeyFields = groupedInvoiceDocumentDetails.filter(d => d.ioNumber === rowData.ioNumber);

				isValid = !(groupedFilteredOnKeyFields.some(d => {

					var remainingAmount = (Number(zeroIfNull(d.poAmount).toFixed(2)) - Number(zeroIfNull(d.consumedAmount).toFixed(2)));
					var isInvoiceAmountInvalid = Number(Number(zeroIfNull(parseFloat(d.ioInvoiceAmount || 0))).toFixed(2)) > Number(remainingAmount.toFixed(2));
					if (isInvoiceAmountInvalid) {
						if (d.tolerancePOFlag === 'N') {
							var remainingWithTol = Number((zeroIfNull(remainingAmount) + zeroIfNull(d.tolerancePOAmount)).toFixed(2));
							if (remainingWithTol < 0)
								remainingWithTol = 0
							isInvoiceAmountInvalid = Number(zeroIfNull(parseFloat(d.ioInvoiceAmount || 0)).toFixed(2)) > Number((remainingWithTol).toFixed(2));
						}
						else {
							var percentRemainingAmount = (zeroIfNull(d.tolerancePOAmount) * zeroIfNull(d.poAmount)) / 100.00;
							var remainingWithTol = Number((zeroIfNull(remainingAmount) + percentRemainingAmount).toFixed(2));
							if (remainingWithTol < 0)
								remainingWithTol = 0
							isInvoiceAmountInvalid = Number(Number(d.ioInvoiceAmount).toFixed(2)) > Number((remainingWithTol).toFixed(2));
						}
					}
					return isInvoiceAmountInvalid;
				}));
			}
		}
		return isValid;
	}

	//#endregion Validations

	//#region APICalls


	const getUpdatedData = (row, poCode) => {
		var invoiceDocument = invoiceState.invoiceDocument;
		props.info.inProgress(true);
		var url = "/api/invoicedocument/refetchpoinfo/" + props.info.modelDefId + '?poCode=' + encodeURIComponent(poCode);
		if (props.info.modelDefId === 1) {
			const serviceStartDate = invoiceDocument.serviceTermStartDate;
			const serviceEndDate = invoiceDocument.serviceTermEndDate;
			const params = [];
			if (serviceStartDate) params.push('serviceStartDate=' + encodeURIComponent(serviceStartDate));
			if (serviceEndDate) params.push('serviceEndDate=' + encodeURIComponent(serviceEndDate));
			if (params.length > 0) url += '&' + params.join('&');
		}
		httpGet(url)
			.then((response) => {
				var data = response.data;
				if (props.info.modelDefId === 1) {
					invoiceDocument.invoiceDocumentEditorDetails.forEach(item => {
						if (!stringIsNullOrEmpty(item.ioNumber) && item.ioNumber.trim() === data.poCode.trim()) {
							item.poAmount = data.poAmount;
							item.consumedAmount = data.consumedAmount;
							item.deliveryAmount = data.deliveryAmount;
							item.isIONumberValid = 'Y';
							item.isIOUpdated = true;
						}
					});
					var item = currentEditRow;
					if (item && !stringIsNullOrEmpty(item.ioNumber) && item.ioNumber.trim() === data.poCode.trim()) {
						item.poAmount = data.poAmount;
						item.consumedAmount = data.consumedAmount;
						item.deliveryAmount = data.deliveryAmount;
						item.isIONumberValid = 'Y';
						item.isIOUpdated = true;
					}
				}
				else {
					invoiceDocument.invoiceDocumentEditorDetails.forEach(item => {
						item.netCost = data.poAmount;
						item.matchToDateNet = data.consumedAmount;
						item.remainingAmount = data.poAmount - data.consumedAmount;
						item.isPOCodeValid = 'Y';
					});
					var item = currentEditRow;
					if (item) {
						item.poAmount = data.poAmount;
						item.consumedAmount = data.consumedAmount;
						item.remainingAmount = data.poAmount - data.consumedAmount;
						item.isPOCodeValid = 'Y';
					}
				}
				props.info.inProgress(false);
				setInvoiceState((prev) => ({
					...prev, invoiceDocument: {
						...prev.invoiceDocument,
						invoiceDocumentEditorDetails: invoiceDocument.invoiceDocumentEditorDetails.map(e => e)
					}
				}));
			}).catch((error) => {
				props.info.inProgress(false);
				toast.error('Error fetching IO/PO info');
			});
	}


	const fetchLevel3 = (level2Key, row) => {
		var poCode = stringIsNullOrEmpty(invoiceState.invoiceDocument?.poCode) ? "" : "&poCode=" + encodeURIComponent(invoiceState.invoiceDocument?.poCode);
		props.info.inProgress(true);
		httpGet("/api/lookup/level3list?level2Key=" + encodeURIComponent(level2Key) + poCode)
			.then((response) => {
				var data = response.data;
				if (data.length === 1) {
					row.level3Key = data[0].level3Key;
					row.costType = data[0].costType;
					row.isLevel3KeyValid = 'Y';
					updateStateOnCallback();
					fetchCostCodes(row.level2Key, row.level3Key, row);
				}
				props.info.inProgress(false);
			}).catch((error) => {
				props.info.inProgress(false);
				toast.error('Error fetching Activity');
			});
	}
	const fetchCostCodes = (level2Key, level3Key, row) => {
		var poCode = stringIsNullOrEmpty(invoiceState.invoiceDocument?.poCode) ? "" : "&poCode=" + encodeURIComponent(invoiceState.invoiceDocument?.poCode);
		props.info.inProgress(true);
		httpGet("/api/lookup/costcodeslist?level2Key=" + encodeURIComponent(level2Key) + "&level3Key=" + encodeURIComponent(level3Key) + poCode)
			.then((response) => {
				var data = response.data;
				if (data.length === 1) {
					row.resType = data[0].resType;
					row.rTypeName = data[0].rTypeName;
					row.isCostCodesValid = 'Y';
					row.netCost = data[0].netCost;
					row.matchToDateNet = data[0].matchToDateNet;
					row.remainingAmount = data[0].remainingAmount;
					updateStateOnCallback();
				}
				props.info.inProgress(false);
			}).catch((error) => {
				props.info.inProgress(false);
				toast.error('Error fetching Expense Type/Cost Codes');
			});
	}

	const updateStateOnCallback = React.useCallback(() => {
		let details = invoiceState.invoiceDocument?.invoiceDocumentEditorDetails;
		let someValid = validateAllRows(details) || details.length === 0
		stateUpliftMethods.setParentState({ isGridDataValid: someValid, isDirty: true });
		setIsGridDataValid(someValid);
		setState({ ...state, isDirty: true, openLevel2Dialog: false, openLevel3Dialog: false });
	})


	//#endregion APICalls
	//#region validation
	const setValidationonBlur = React.useCallback((row, notify) => {
		validateAllRows(null, row);
	});
	const validateAllRows = React.useCallback((invoiceDocumentEditorDetails, sender) => {
		const sourceDetails = invoiceDocumentEditorDetails || invoiceState.invoiceDocument?.invoiceDocumentEditorDetails || [];
		const validatableDetails = isPartialPostMode
			? sourceDetails.filter(d => Number(partialMoInvoiceMap?.get(String(d.seqId ?? ''))?.posted) !== 1)
			: sourceDetails;
		return triggerValidation(validatableDetails, false, sender);
	}, [triggerValidation, invoiceState.invoiceDocument?.invoiceDocumentEditorDetails, isPartialPostMode, partialMoInvoiceMap]);
	// validation and validateIfNotEmpty moved to context
	const isDataSame = React.useCallback((image, newLines) => {
		for (let i = 0; i < image.length; i++) {
			if (props.info.modelDefId === 1) {
				if (image[i].ioNumber !== newLines[i].ioNumber
					|| image[i].taxCode !== newLines[i].taxCode
					|| image[i].seqId !== newLines[i].seqId
					|| image[i].ioInvoiceAmount !== newLines[i].ioInvoiceAmount
					|| image[i].ioDescription != newLines[i].ioDescription
				) {
					return false;
				}
			}
			else {
				if (image[i].level2Key !== newLines[i].level2Key
					|| image[i].level3Key !== newLines[i].level3Key
					|| image[i].rTypeName !== newLines[i].rTypeName
					|| image[i].taxCode !== newLines[i].taxCode
					|| image[i].seqId !== newLines[i].seqId
					|| image[i].ioInvoiceAmount !== newLines[i].ioInvoiceAmount
					|| image[i].ioDescription != newLines[i].ioDescription
					|| image[i].quantity !== newLines[i].quantity
				) {
					return false;
				}
			}
		}
		return true;
	}, []);
	const getStatusAndValidate = React.useCallback((cellProps, lineStatus, status) => {
		let newStatus = status;
		if (lineStatus % 20 === 0 && lineStatus === 180) {
			return 'Post Failed';
		}
		if (Number(lineStatus) === 40) {
			const hasAssignedIo = !stringIsNullOrEmpty(cellProps.row?.ioNumber || cellProps.row?.poCode);
			if (!hasAssignedIo) return '';
			lineStatus = 50;
		}

		let companyConfig = invoiceState.invoiceDocument?.companyApprovalConfiguration;
		let isMaxed = (lineStatus % 20 !== 0) && ((lineStatus - 50) / 20) >= companyConfig?.routingNumberOfApprovalLevels;
		let level = 1;
		if (isMaxed) {
			newStatus = companyConfig[`approvalLevel${(lineStatus % 20 !== 0) && ((lineStatus - 50) / 20)}AcceptName`];
		} else {
			if (lineStatus % 20 === 0) {
				level = (lineStatus - 30 - 50) / 20;
			}
			else {
				level = (lineStatus === 50) ? 1 : (lineStatus + 20 - 50) / 20;
			}
			newStatus = 'Pending ' + companyConfig[`approvalLevel${level}AcceptName`];
			if (level <= 0) {
				newStatus = '';
			}
		}
		if (cellProps.row.statusDescription) {
			if (cellProps.row.statusDescription === 'Approved') {
				newStatus = companyConfig[`approvalLevel${level}AcceptName`]
			} else {
				newStatus = companyConfig[`approvalLevel${level}RejectName`]
			}
		}
		return newStatus || status;
	}, [invoiceState.invoiceDocument?.companyApprovalConfiguration])
	//#endregion

	//#region renderer

	const uniqueBy = (arr, keyProps) => {
		const kvArray = arr.map(entry => {
			const key = keyProps.map(k => entry[k]).join('|');
			return [key, entry];
		});
		const map = new Map(kvArray);
		return Array.from(map.values());
	}

	const calculateTaxAmount = (taxCode, row) => {
		let originalAmount = 0;
		try {
			if (row.taxAmount && !isNaN(row.taxAmount))
				originalAmount = parseFloat(row.taxAmount)
		} catch (ex) { }
		row.taxAmount = 0.00;
		row.invoiceDocumentDetailTaxes = [];
		if (!stringIsNullOrEmpty(taxCode)) {
			var taxes = invoiceState.invoiceDocument.taxes.filter(t => t.taxCode === taxCode);
			let totalTaxBaseOnIoAmount = taxes.map((e, i) => calculateTax(e, row.ioInvoiceAmount)).reduce((prev, next) => prev + next, 0);
			taxes.forEach(tax => {
				let calculatedTaxAmount = (row.isTaxManuallyChanged)
					? getPropotionAndApplyTax(tax, row.ioInvoiceAmount, totalTaxBaseOnIoAmount, originalAmount)
					: isNaN(row.ioInvoiceAmount)
						? 0.00
						: calculateTax(tax, row.ioInvoiceAmount);

				calculatedTaxAmount = parseFloat(calculatedTaxAmount.toFixed(2));

				row.invoiceDocumentDetailTaxes.push({
					companyCode: row.companyCode,
					invoiceDocumentId: row.invoiceDocumentId,
					seqId: row.seqId,
					taxCode: tax.taxCode,
					taxTypeCode: tax.taxTypeCode,
					taxPrc: tax.otherTaxAmt,
					taxAmount: calculatedTaxAmount
				});
			});
			if (row.invoiceDocumentDetailTaxes) {
				if (row.isTaxManuallyChanged) {
					if (row.ioInvoiceAmount == 0) {
						originalAmount = 0;
					}
					row.taxAmount = originalAmount;
					if (row.taxAmount === 0) {
						row.invoiceDocumentDetailTaxes = [];
						row.taxCode = '';
					}
				}
				else {
					row.taxAmount = row.invoiceDocumentDetailTaxes.map(item => item.taxAmount).reduce((prev, next) => prev + next, 0);
					row.taxAmount = parseFloat(row.taxAmount.toFixed(2));
				}
			}
		}
	}
	const getPropotionAndApplyTax = (tax, ioAmount, initialTaxAmount, newTaxAmount) => {
		if (ioAmount !== 0) {
			let getAmountProportion = initialTaxAmount === 0 ? calculateTax(tax, ioAmount) : calculateTax(tax, ioAmount) / initialTaxAmount;
			return getAmountProportion * newTaxAmount;
		}
		return 0;
	}


	var info = props.info;
	info.openDialog = state.openVendorDialog;

	info.invoiceModel = { vendorCode: invoiceState.invoiceDocument?.vendorCode, siteId: invoiceState.invoiceDocument?.siteId, currencyCode: "" };

	var clientInfo = props.clientInfo;
	clientInfo.openDialog = state.openClientDialog;

	clientInfo.invoiceModel = { clientCode: invoiceState.invoiceDocument?.clientCode };

	const level2Info = {
		inProgress: props.info.inProgress,
		openDialog: state.openLevel2Dialog,
		poCode: blankStringIfNullOrEmpty(invoiceState.invoiceDocument?.poCode),
		noPoFlag: invoiceState.invoiceDocument?.noPoFlag,
		clientCode: invoiceState.invoiceDocument?.clientCode,
		level2Key: currentEditRow ? currentEditRow.level2Key : null,
		lineStatuses: state.level2SelectionContext?.lineStatuses || []
	};
	const level3Info = {
		inProgress: props.info.inProgress,
		openDialog: state.openLevel3Dialog,
		level2Key: currentEditRow ? currentEditRow.level2Key : null,
		poCode: blankStringIfNullOrEmpty(invoiceState.invoiceDocument?.poCode),
		level3Key: currentEditRow ? currentEditRow.level3Key : null,
		refreshKey: level3RefreshKey
	};
	const costCodesInfo = {
		inProgress: props.info.inProgress,
		openDialog: state.openCostCodesDialog,
		level2Key: currentEditRow ? currentEditRow.level2Key : null,
		level3Key: currentEditRow ? currentEditRow.level3Key : null,
		poCode: blankStringIfNullOrEmpty(invoiceState.invoiceDocument?.poCode),
		resType: currentEditRow ? currentEditRow.resType : null
	};
	let readOnlyRow = props.readOnly;
	const originalInvoiceStatus = Number(props.originalInvoiceDocumentStatus);
	const withRowDisabled = (renderFn) => (cellProps) => {
		if (overRideAllChecks) {
			return renderFn(cellProps, true);
		}

		const row = cellProps.row;

		// 🚨 PARTIAL POST MODE — HARD OVERRIDE
		if (isPartialPostMode) {
			const seqId = String(row.seqId ?? 0);
			const moInfo = partialMoInvoiceMap?.get(seqId);
			const isPostedLine = Number(moInfo?.posted) === 1;

			const isSelectedLine =
				!isPostedLine &&
				!!partialEditableIONumberSet &&
				partialEditableIONumberSet.has(seqId);

			// Selected → editable, Non-selected → read-only
			return renderFn(cellProps, isSelectedLine);
		}

		// ---------- NORMAL FLOW (VIEW / EDIT) ----------
		const lineStatus = Number(row.lineStatus);

		//const isLockedApprovedLine =
		//	originalInvoiceStatus === 40 &&
		//	!isNaN(lineStatus) &&
		//	lineStatus >= 70 &&
		//	lineStatus !== 100;

		const baseEditable =
			(row.hasAuthority === 'Y' && row.allowInvoiceCorrection === 'Y') ||
			row.lineStatus <= 50 ||
			row.lineStatus === 180;

		const rowEnabled =
			!readOnlyRow &&
			baseEditable
		//&& !isLockedApprovedLine;

		return renderFn(cellProps, rowEnabled);
	};


	const cellStyle = { paddingLeft: 8, paddingRight: 28, textAlign: "right" };

	const cellEditable = props.editable;
	const isEditableByRule = props.isEditableByRule;
	const isFieldReadOnly = props.isFieldReadOnly;
	//#endregion renderer



	//#region columns
	const headCells = React.useMemo(() => {
		const approvalColumn = !props.isVendorChanged && !isPartialPostMode && props.originalInvoiceDocumentStatus >= 50 &&
			props.originalInvoiceDocumentStatus !== 60 && props.info?.mode?.toLowerCase() !== 'test' ? {
			headerName: 'Approval Status',
			field: 'nextLevelApprovalDescription',
			cellStyle: { padding: 8 },
			align: 'left',
			headerAlign: 'left',
			width: 200,
			editable: true,
			resizable: false,
			renderCell: (cellProps) => {
				let status = cellProps.row.nextLevelApprovalDescription ?? "";
				let lineStatus = cellProps.row.lineStatus;
				status = getStatusAndValidate(cellProps, lineStatus, status);
				return (
					<Grid container className="iconContainer" alignItems="center" wrap="nowrap">
						<Grid
							item
							xs
							style={{
								minWidth: 0,
								whiteSpace: 'normal',
								wordBreak: 'break-word',
								lineHeight: '1.3',
								paddingRight: 28
							}}
						>
							{status === 'Approved' || status === 'Rejected' || lineStatus === 110 ? status : (status === "" ? " " : `${status}`)}
						</Grid>
						{
							props.info.mode?.toLowerCase() !== 'test' &&
							<Grid
								item
								style={{
									flex: '0 0 auto',
									marginLeft: 8
								}}
							>
								<Grid item key={cellProps.row + 1}>
									<Tooltip title="View History">
										<IconButton
											id={`approval-history-${cellProps.row.seqId}`}
											value="color"
											aria-label="Add Comment"
											className="textAlignmentIcon"
											onClick={(e) => {
												props.routingHistory_clickHandler(
													invoiceState.invoiceDocument.invoiceDocumentId,
													cellProps.row.seqId
												);
											}}
											style={{ padding: 0, margin: 0, verticalAlign: 'middle' }}
										>
											<HistoryIcon style={{ verticalAlign: 'middle' }} />
										</IconButton>
									</Tooltip>
								</Grid>
							</Grid>
						}
					</Grid>
				);
			},
			renderEditCell: (cellProps) => {
				let status = cellProps.row.nextLevelApprovalDescription ?? "";
				let lineStatus = cellProps.row.lineStatus;
				status = getStatusAndValidate(cellProps, lineStatus, status);
				return (
					<Grid container className="iconContainer" alignItems="center" wrap="nowrap">
						<Grid
							item
							xs
							style={{
								minWidth: 0,
								whiteSpace: 'normal',
								wordBreak: 'break-word',
								lineHeight: '1.3',
								paddingRight: 28
							}}
						>

							{status === 'Approved' || status === 'Rejected' || lineStatus === 110 ? status : (status === "" ? " " : `${status}`)}
						</Grid>
						{
							props.info.mode?.toLowerCase() !== 'test' &&
							<Grid
								item
								style={{
									flex: '0 0 auto',
									marginLeft: 8
								}}
							>
								<Grid item key={cellProps.row + 1}>
									<Tooltip title="View History">
										<IconButton
											id={`approval-history-edit-${cellProps.row.seqId}`}
											value="color"
											aria-label="Add Comment"
											className="textAlignmentIcon"
											onClick={(e) => {
												props.routingHistory_clickHandler(
													invoiceState.invoiceDocument.invoiceDocumentId,
													cellProps.row.seqId
												);
											}}
											style={{ padding: 0, margin: 0, verticalAlign: 'middle' }}
										>
											<HistoryIcon style={{ verticalAlign: 'middle' }} />
										</IconButton>
									</Tooltip>
								</Grid>
							</Grid>
						}

					</Grid>
				);
			}
		} : null;

		const moInvoiceColumn = isPartialPostMode ? {
			headerName: 'MO Invoice Number',
			field: 'moInvoiceDisplay',
			cellStyle: { padding: 8 },
			align: 'left',
			headerAlign: 'left',
			width: 180,
			resizable: false,
			sortable: false,
			renderCell: (cellProps) => {
				const ioKey = String(cellProps?.row?.seqId ?? '');
				const moInfo = partialMoInvoiceMap?.get(ioKey);
				if (!moInfo?.intInvoiceNumber) return '';
				return `${moInfo.intInvoiceNumber} (${Number(moInfo.posted) === 1 ? 'Posted' : 'Failed to post'})`;
			}
		} : null;

		return [
			...(approvalColumn ? [approvalColumn] : []),
			...(moInvoiceColumn ? [moInvoiceColumn] : []),
			{
				headerName: 'IO/PO Number',
				field: 'ioNumber',
				cellStyle: { padding: 8 },
				editable: cellEditable ? isEditableByRule("IO/PO Number") : false,
				resizable: false,
				width: 200,
				renderCell: withRowDisabled((props, rowDisabled) => {
					const mediaType = props.row.mediaType || '';

					if (rowDisabled) {
						return (
							<Grid key={0} container className="iconContainer">
								<Grid
									item
									xs={9}
									style={{
										alignSelf: 'center',
										display: 'flex',
										alignItems: 'center',
										gap: 4,
										minWidth: 0
									}}
								>
									<div style={{
										flexGrow: 1,
										display: 'flex',
										flexDirection: 'column',
										minWidth: 0
									}}>
										<span style={{
											display: 'inline-flex',
											alignItems: 'center',
											minHeight: 18,
											wordBreak: 'break-word',
											whiteSpace: 'normal',
											lineHeight: 1.2
										}}>
											<span style={{
												wordBreak: 'break-word',
												whiteSpace: 'normal',
												overflowWrap: 'anywhere',
												flexShrink: 1
											}}>
												{props.row.ioNumber}
											</span>
											<span
												style={{
															color: showIONumberWarning(props.row) ? "red" : "",
															display: showIONumberWarning(props.row) ? "" : "none",
													marginLeft: 4,
													fontWeight: 700
												}}
											>
												*
											</span>
										</span>
										<span style={{
											fontSize: '0.8em',
											color: 'grey',
											fontWeight: 'bold',
											marginTop: 2
										}}>
											{mediaType}
										</span>
									</div>
									{props.row.ioNumber && !isPartialPostMode && canShowClearIcon(props.row) && (
										<Tooltip title="Clear IO/PO Number" arrow>
											<IconButton
												size="small"
												onClick={(e) => {
													e.stopPropagation();
													clearIONumberHandler(props.row);
												}}
												sx={{
													color: '#d32f2f',
													ml: 0.5,
													'&:hover': { backgroundColor: 'rgba(211,47,47,0.08)' }
												}}
											>
												<ClearIcon fontSize="small" />
											</IconButton>
										</Tooltip>
									)}
										{hasPlacementLevelMatch(props.row) && renderPlacementDetails(props.row)}
								</Grid>
								<Grid key={1} item xs={3} style={{ alignSelf: 'center' }}>
									<IconButton id={`search-io-po-${props.row.seqId}`} value="color" disabled={!cellEditable ? true : !isEditableByRule("IO/PO Number")} aria-label="Field Source" className="textAlignmentIcon" onClick={(e) => {
										searchIONumber_clickHandler(e, props.row);
									}}>
										<SearchIcon />
									</IconButton>
								</Grid>
							</Grid>
						);
					}
					return (
						<div style={{
							display: 'flex',
							flexDirection: 'column',
							minWidth: 0
						}}>
							<span style={{
								display: 'inline-flex',
								alignItems: 'center',
								minHeight: 18,
								wordBreak: 'break-word',
								whiteSpace: 'normal',
								lineHeight: 1.2
							}}>
								<span style={{
									wordBreak: 'break-word',
									whiteSpace: 'normal',
									overflowWrap: 'anywhere',
									flexShrink: 1
								}}>
									{props.row.ioNumber}
								</span>
								<span
									style={{
										color: showIONumberWarning(props.row) ? "red" : "",
											display: showIONumberWarning(props.row) ? "" : "none",
										marginLeft: 4,
										fontWeight: 700
									}}
								>
									*
								</span>
								{hasPlacementLevelMatch(props.row) && (
									<span style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 8 }}>
										{renderPlacementDetails(props.row)}
									</span>
								)}
							</span>
							<span style={{
								fontSize: '0.8em',
								color: 'grey',
								fontWeight: 'bold',
								marginTop: 2
							}}>
								{mediaType}
							</span>
						</div>
					);
				}),
				renderEditCell: withRowDisabled((props, rowDisabled) => {
					const mediaType = props.row.mediaType || '';
					if (rowDisabled) {
						return (
							<Grid key={0} container className="iconContainer">
								<Grid
									item
									xs={9}
									style={{
										alignSelf: 'center',
										display: 'flex',
										alignItems: 'center',
										gap: 4,
										minWidth: 0
									}}
								>
									<div style={{
										flexGrow: 1,
										display: 'flex',
										flexDirection: 'column',
										minWidth: 0
									}}>
										<span style={{
											display: 'inline-flex',
											alignItems: 'center',
											minHeight: 18,
											wordBreak: 'break-word',
											whiteSpace: 'normal',
											lineHeight: 1.2
										}}>
											<span style={{
												wordBreak: 'break-word',
												whiteSpace: 'normal',
												overflowWrap: 'anywhere',
												flexShrink: 1
											}}>
												{props.row.ioNumber}
											</span>
											<span
												style={{
															color: showIONumberWarning(props.row) ? "red" : "",
															display: showIONumberWarning(props.row) ? "" : "none",
													marginLeft: 4,
													fontWeight: 700
												}}
											>
												*
											</span>
										</span>
										<span style={{
											fontSize: '0.8em',
											color: 'grey',
											fontWeight: 'bold',
											marginTop: 2
										}}>
											{mediaType}
										</span>
									</div>
									{props.row.ioNumber && canShowClearIcon(props.row) && (
										<Tooltip title="Clear IO/PO Number" arrow>
											<IconButton
													id={`clear-io-po-edit-${props.row.seqId}`}
												size="small"
												onClick={(e) => {
													e.stopPropagation();
													clearIONumberHandler(props.row);
												}}
												sx={{
													color: '#d32f2f',
													ml: 0.5,
													'&:hover': { backgroundColor: 'rgba(211,47,47,0.08)' }
												}}
											>
												<ClearIcon fontSize="small" />
											</IconButton>
										</Tooltip>
									)}
									{hasPlacementLevelMatch(props.row) && renderPlacementDetails(props.row)}
								</Grid>
								<Grid key={1} item xs={3} style={{ alignSelf: 'center' }}>
									<IconButton id={`search-io-po-edit-${props.row.seqId}`} value="color" disabled={!cellEditable ? true : !isEditableByRule("IO/PO Number")} aria-label="Field Source" className="textAlignmentIcon" onClick={(e) => {
										searchIONumber_clickHandler(e, props.row);
									}}>
										<SearchIcon />
									</IconButton>
								</Grid>
							</Grid>
						);
					}
					return (
						<div style={{
							display: 'flex',
							flexDirection: 'column',
							minWidth: 0
						}}>
							<span style={{
								display: 'inline-flex',
								alignItems: 'center',
								minHeight: 18,
								wordBreak: 'break-word',
								whiteSpace: 'normal',
								lineHeight: 1.2
							}}>
								<span style={{
									wordBreak: 'break-word',
									whiteSpace: 'normal',
									overflowWrap: 'anywhere',
									flexShrink: 1
								}}>
									{props.value}
								</span>
								<span
									style={{
										color: showIONumberWarning(props.row) ? "red" : "",
											display: showIONumberWarning(props.row) ? "" : "none",
										marginLeft: 4,
										fontWeight: 700
									}}
								>
									*
								</span>
								{hasPlacementLevelMatch(props.row) && (
									<span style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 4 }}>
										{renderPlacementDetails(props.row)}
									</span>
								)}
							</span>
							<span style={{
								fontSize: '0.8em',
								color: 'grey',
								fontWeight: 'bold',
								marginTop: 2
							}}>
								{mediaType}
							</span>
						</div>
					);
				}),
			},

			{
				headerName: 'IO/PO Description',
				field: 'ioDescription',
				cellStyle: { padding: 8 },
				editable: cellEditable ? isEditableByRule("IO/PO Description") : false,
				resizable: false,
				width: 150,
				renderCell: withRowDisabled((props, rowDisabled) => {
					if (rowDisabled) {
						return (<div style={{ fontSize: 13, width: 150 }}>
							<Tooltip title={props.row.ioDescription || ''}>
							<input
								id={`ioDescription-${props.id}`}
								type="text"
								aria-invalid="false"
								placeholder="IO/PO Description"
								value={props.row.ioDescription || ''}
								readOnly={!cellEditable ? true : !isEditableByRule("IO/PO Description")}
									className="MuiInputBase-input MuiInput-input"
									style={{ width: "90%" }}
									onChange={(event) => {
										const newValue = event.target.value;
										setInvoiceState({
											...invoiceState,
											isDirty: true,
											invoiceDocument: {
												...invoiceState.invoiceDocument,
												invoiceDocumentEditorDetails:
													invoiceState.invoiceDocument?.invoiceDocumentEditorDetails.map((e) =>
														e.seqId === props.id ? { ...e, [props.field]: newValue, isDirty: true } : e
													)
											}
										});
										setState({ ...state });
									}}
								/>
							</Tooltip>
						</div>
						);
					}
					return (
						<Tooltip title={props.row.ioDescription || ''}>
							<span style={{ display: 'inline-block', pointerEvents: 'auto' }}>
								<div
									className="two-line-ellipsis"
									style={{ width: 150, fontSize: 13 }}
								>
									{props.row.ioDescription}
								</div>
							</span>
						</Tooltip>
					);
				}),
				renderEditCell: withRowDisabled((props, rowDisabled) => {
					if (rowDisabled) {
						return (<div style={{ fontSize: 13, width: 150 }}>
							<Tooltip title={props.value || ''}>
								<input
									id={`ioDescription-edit-${props.id}`}
									type="text"
									aria-invalid="false"
									placeholder="IO/PO Description"
									readOnly={!cellEditable ? true : !isEditableByRule("IO/PO Description")}
									value={props.value || ''}
									className="MuiInputBase-input MuiInput-input"
									style={{ width: "90%" }}
									onChange={(event) => {
										const newValue = event.target.value;
										setInvoiceState({
											...invoiceState, isDirty: true, invoiceDocument: {
												...invoiceState.invoiceDocument,
												invoiceDocumentEditorDetails:
													invoiceState.invoiceDocument?.invoiceDocumentEditorDetails.map((e) =>
														e.seqId === props.id ? { ...e, [props.field]: newValue, isDirty: true } : e
													)
											}
										});
										setState({
											...state
										})
									}}
								/>
							</Tooltip>
						</div>
						);
					}
					return (
						<Tooltip title={props.value || ''}>
							<span style={{ display: 'inline-block', pointerEvents: 'auto' }}>
								<div
									className="two-line-ellipsis"
									style={{ width: 150, fontSize: 13 }}
								>
									{props.value}
								</div>
							</span>
						</Tooltip>
					);

				})
			},
			{
				headerName: 'Project',
				field: 'level2Key',
				cellStyle: { padding: 8 },
				defaultGroupOrder: -1,
				editable: cellEditable ? isEditableByRule("Project") : false,
				resizable: false,
				width: 150,
				renderCell: withRowDisabled((props, rowDisabled) => {
					if (rowDisabled) {
						return (
							<Grid key={0} container className="iconContainer">
								<Grid
									item
									xs={9}
									style={{
										wordBreak: 'break-word',
										alignSelf: 'center',
										display: 'flex',
										alignItems: 'center',
										gap: 4
									}}
								>
									<div style={{ flexGrow: 1 }}>
										{props.row.level2Key}
										<span
											style={{
												color: Level2KeyValid(props.row) ? "" : "red",
												display: Level2KeyValid(props.row) ? "none" : ""
											}}
										>
											*
										</span>
									</div>

									{props.row.level2Key && canShowClearIcon(props.row) && (
										<Tooltip title="Clear Project" arrow>
											<IconButton
													id={`clear-project-${props.row.seqId}`}
												size="small"
												onClick={(e) => {
													e.stopPropagation();
													clearLevel2Handler(props.row);
												}}
												sx={{
													color: '#d32f2f',
													ml: 0.5,
													'&:hover': { backgroundColor: 'rgba(211,47,47,0.08)' }
												}}
											>
												<ClearIcon fontSize="small" />
											</IconButton>
										</Tooltip>
									)}

								</Grid>

								<Grid key={1} item xs={3} style={{ alignSelf: 'center' }}>
									<IconButton id={`search-project-${props.row.seqId}`} value="color" disabled={!cellEditable ? true : !isEditableByRule("Project")} aria-label="Field Source" className="textAlignmentIcon" onClick={(e) => {
										searchLevel2_clickHandler(e, props.row);
									}}>
										<SearchIcon />
									</IconButton>
								</Grid>
							</Grid>
						);
					}
					return <div>{props.row.level2Key} <span style={{ color: Level2KeyValid(props.row) ? "" : "red", display: Level2KeyValid(props.row) ? "none" : "" }}>*</span></div>;
				}),
				renderEditCell: withRowDisabled((props, rowDisabled) => {
					if (rowDisabled) {
						return (
							<Grid key={0} container className="iconContainer">
								<Grid
									item
									xs={9}
									style={{
										wordBreak: 'break-word',
										alignSelf: 'center',
										display: 'flex',
										alignItems: 'center',
										gap: 4
									}}
								>
									<div style={{ flexGrow: 1 }}>
										{props.row.level2Key}
										<span
											style={{
												color: Level2KeyValid(props.row) ? "" : "red",
												display: Level2KeyValid(props.row) ? "none" : ""
											}}
										>
											*
										</span>
									</div>

									{props.row.level2Key && canShowClearIcon(props.row) && (
										<Tooltip title="Clear Project" arrow>
											<IconButton
													id={`clear-project-edit-${props.row.seqId}`}
												size="small"
												onClick={(e) => {
													e.stopPropagation();
													clearLevel2Handler(props.row);
												}}
												sx={{
													color: '#d32f2f',
													ml: 0.5,
													'&:hover': { backgroundColor: 'rgba(211,47,47,0.08)' }
												}}
											>
												<ClearIcon fontSize="small" />
											</IconButton>
										</Tooltip>
									)}

								</Grid>

								<Grid key={1} item xs={3} style={{ alignSelf: 'center' }}>
									<IconButton id={`search-project-edit-${props.row.seqId}`} value="color" disabled={!cellEditable ? true : !isEditableByRule("Project")} aria-label="Field Source" className="textAlignmentIcon" onClick={(e) => {
										searchLevel2_clickHandler(e, props.row);
									}}>
										<SearchIcon />
									</IconButton>
								</Grid>
							</Grid>
						);
					}
					return <div>{props.value}</div>;
				})
			},
			{
				headerName: 'Activity',
				field: 'level3Key',
				cellStyle: { padding: 8 },
				defaultGroupOrder: -1,
				editable: cellEditable ? isEditableByRule("Activity") : false,
				resizable: false,
				width: 150,
				renderCell: withRowDisabled((props, rowDisabled) => {
					if (rowDisabled) {
						return (<Grid key={0} container className="iconContainer">
							<Grid key={0} item xs={9} style={{ wordBreak: 'break-word', alignSelf: 'center' }}>
								{props.row.level3Key} <span style={{ color: Level3KeyValid(props.row) ? "" : "red", display: Level3KeyValid(props.row) ? "none" : "" }}>*</span>
							</Grid>
							<Grid key={1} item xs={3} style={{ alignSelf: 'center' }}>
								<IconButton id={`search-activity-${props.row.seqId}`} value="color" disabled={!cellEditable ? true : !isEditableByRule("Activity")} aria-label="Field Source" className="textAlignmentIcon" onClick={(e) => {
									searchLevel3_clickHandler(e, props.row);
								}}>
									<SearchIcon />
								</IconButton>
							</Grid>
						</Grid>
						);
					}
					return <div>{props.row.level3Key} <span style={{ color: Level3KeyValid(props.row) ? "" : "red", display: Level3KeyValid(props.row) ? "none" : "" }}>*</span></div>;
				}),
				renderEditCell: withRowDisabled((props, rowDisabled) => {
					if (rowDisabled) {
						return (<Grid key={0} container className="iconContainer">
							<Grid key={0} item xs={9} style={{ wordBreak: 'break-word', alignSelf: 'center' }}>
								{props.value} <span style={{ color: Level3KeyValid(props.row) ? "" : "red", display: Level3KeyValid(props.row) ? "none" : "" }}>*</span>
							</Grid>
							<Grid key={1} item xs={3} style={{ alignSelf: 'center' }}>
								<IconButton id={`search-activity-edit-${props.row.seqId}`} value="color" disabled={!cellEditable ? true : !isEditableByRule("Activity")} aria-label="Field Source" className="textAlignmentIcon" onClick={(e) => {
									searchLevel3_clickHandler(e, props.row);
								}}>
									<SearchIcon />
								</IconButton>
							</Grid>
						</Grid>
						)
					}
					return <div>{props.value}</div>;
				})
			},
			{
				headerName: 'Expense Type',
				field: 'rTypeName',
				cellStyle: { padding: 8 },
				defaultGroupOrder: -1,
				editable: cellEditable ? isEditableByRule("Expense Type") : false,
				resizable: false,
				width: 150,
				renderCell: withRowDisabled((props, rowDisabled) => {
					if (rowDisabled) {
						return (<Grid key={0} container className="iconContainer">
							<Grid key={0} item xs={9} style={{ wordBreak: 'break-word', alignSelf: 'center' }}>
								{props.row.rTypeName} <span style={{ color: CostCodesValid(props.row) ? "" : "red", display: CostCodesValid(props.row) ? "none" : "" }}>*</span>
							</Grid>
							<Grid key={1} item xs={3} style={{ alignSelf: 'center' }}>
								<IconButton id={`search-expense-type-${props.row.seqId}`} value="color" disabled={!cellEditable ? true : !isEditableByRule("Expense Type")} aria-label="Field Source" className="textAlignmentIcon" onClick={(e) => {
									searchCostCodes_clickHandler(e, props.row);
								}}>
									<SearchIcon />
								</IconButton>
							</Grid>
						</Grid>
						)
					}
					return <div>{props.row.rTypeName} <span style={{ color: CostCodesValid(props.row) ? "" : "red", display: CostCodesValid(props.row) ? "none" : "" }}>*</span></div>;
				}),
				renderEditCell: withRowDisabled((props, rowDisabled) => {
					if (rowDisabled) {
						return (<Grid key={0} container className="iconContainer">
							<Grid key={0} item xs={9} style={{ wordBreak: 'break-word', alignSelf: 'center' }}>
								{props.value} <span style={{ color: CostCodesValid(props.row) ? "" : "red", display: CostCodesValid(props.row) ? "none" : "" }}>*</span>
							</Grid>
							<Grid key={1} item xs={3} style={{ alignSelf: 'center' }}>
								<IconButton id={`search-expense-type-edit-${props.row.seqId}`} value="color" disabled={!cellEditable ? true : !isEditableByRule("Expense Type")} aria-label="Field Source" className="textAlignmentIcon" onClick={(e) => {
									searchCostCodes_clickHandler(e, props.row);
								}}>
									<SearchIcon />
								</IconButton>
							</Grid>
						</Grid>
						)
					}
					return <div>{props.value}</div>;
				})
			},
			{
				headerName: 'Quantity',
				field: 'quantity',
				type: 'numeric',
				align: 'right',
				headerAlign: 'right',
				editable: cellEditable ? isEditableByRule("Quantity") : false,
				width: 110,
				headerStyle: { paddingRight: 15 },
				renderCell: withRowDisabled((rowData, rowDisabled) => {
					if (rowDisabled) {
						return (<div>
							<input
								id={`quantity-${rowData.id}`}
								type="number"
								aria-invalid="false"
								placeholder="Quantity"
								value={rowData.row.quantity}
								readOnly={!cellEditable ? true : !isEditableByRule("Quantity")}
								className={`MuiInputBase-input MuiInput-input${validateIfNotEmpty(rowData.row) && rowData.row.quantity <= 0 ? ' MuiInput-input-error' : ''}`}
								style={{ fontSize: 13, textAlign: 'right', width: '100%' }}
								onBlur={e => { setValidationonBlur(rowData.row, true); }}
								onChange={(event) => {
									const newValue = event.target.value;
									setInvoiceState({
										...invoiceState, isDirty: true, invoiceDocument: {
											...invoiceState.invoiceDocument,
											invoiceDocumentEditorDetails: invoiceState.invoiceDocument?.invoiceDocumentEditorDetails
												.map((e, i) => { return (e.seqId === rowData.id) ? { ...e, [rowData.field]: newValue, isDirty: true } : e })
										}
									});
									setState({
										...state
									})
								}}
							/>
						</div>
						);
					}
					return <div>{rowData.row.quantity} <span style={{ color: "", display: "none" }}>*</span></div>;
				}),
				renderEditCell: withRowDisabled((props, rowDisabled) => {
					if (rowDisabled) {
						return (<div>
							<input
								id={`quantity-edit-${props.id}`}
								type="number"
								aria-invalid="false"
								placeholder="Quantity"
								value={props.value}
								readOnly={!cellEditable ? true : !isEditableByRule("Quantity")}
								className={`MuiInputBase-input MuiInput-input${validateIfNotEmpty(props.row) && props.value <= 0 ? ' MuiInput-input-error' : ''}`}
								style={{ fontSize: 13, textAlign: 'right', width: '100%' }}
								onBlur={e => { setValidationonBlur(props.row, true); }}
								onChange={(event) => {
									const newValue = event.target.value;
									setInvoiceState({
										...invoiceState, isDirty: true, invoiceDocument: {
											...invoiceState.invoiceDocument,
											invoiceDocumentEditorDetails: invoiceState.invoiceDocument?.invoiceDocumentEditorDetails
												.map((e, i) => { if (e.seqId === props.id) { return { ...e, [props.field]: newValue } } else return e; })
										}
									});
									setState({
										...state
									})
								}}
							/>
						</div>
						)
					}
					return <div>{props.value}</div>;
				})
			},
			{
				headerName: getDisplayName('site'),
				field: 'siteName',
				cellStyle: { padding: 8 },
				editable: false, // Make it readonly
				resizable: false,
				width: 100,
				renderCell: (props) => {
					return <div key={'site' + 1}>{props.row.siteName || ''}</div>; // Print IO Number
				}
			},
			{
				headerName: invoiceState.invoiceDocument.modelDefId === 2 ? 'Amount' : 'Invoice Net Amount',
				field: 'ioInvoiceAmount',
				type: 'currency',
				cellStyle: cellStyle,
				align: 'right',
				headerAlign: 'right',
				width: 110,
				editable: cellEditable ? isEditableByRule(invoiceState.invoiceDocument.modelDefId === 2 ? 'Amount' : 'Invoice Net Amount') : false,
				resizable: false,
				renderCell: withRowDisabled((rowProps, rowEnabled) => {
					return (
						<EditableAmountCell
							rowProps={rowProps}
							showError={
								invalidRowsList.has(rowProps.row.seqId) &&
								invalidRowsMessage[rowProps.row.seqId]?.type === '1'
							}
							isEditCellMode={false}
							amountFieldType={1}
							formatNumber={formatNumber}
							modelDefId={props.info.modelDefId}
							setBroadCastInvoiceTotal={props.setBroadCastInvoiceTotal}
							setState={setState}
							isEditableByRule={isEditableByRule}
							cellEditable={rowEnabled && cellEditable && !isRowPlacementLocked(rowProps.row)}
							state={state}
							onIoInvoiceAmountBlur={onIoInvoiceAmountBlur}
							setValidationonBlur={setValidationonBlur}
							stateUpliftMethods={stateUpliftMethods}
							style={{ fontSize: 13, textAlign: 'right', width: '100%' }}
							placeholder={
								invoiceState.invoiceDocument.modelDefId === 2 ? 'Amount' : 'Invoice Net Amount'
							}
						/>
					);
				}),
				renderEditCell: withRowDisabled((rowProps, rowEnabled) => {
					return (
						<EditableAmountCell
							rowProps={rowProps}
							showError={
								invalidRowsList.has(rowProps.row.seqId) &&
								invalidRowsMessage[rowProps.row.seqId]?.type === '1'
							}
							isEditCellMode={true}
							amountFieldType={1}
							formatNumber={formatNumber}
							modelDefId={props.info.modelDefId}
							setBroadCastInvoiceTotal={props.setBroadCastInvoiceTotal}
							setState={setState}
							isEditableByRule={isEditableByRule}
							cellEditable={rowEnabled && cellEditable && !isRowPlacementLocked(rowProps.row)}
							state={state}
							onIoInvoiceAmountBlur={onIoInvoiceAmountBlur}
							setValidationonBlur={setValidationonBlur}
							stateUpliftMethods={stateUpliftMethods}
							style={{ fontSize: 13, textAlign: 'right', width: '100%' }}
							placeholder={
								invoiceState.invoiceDocument.modelDefId === 2 ? 'Amount' : 'Invoice Net Amount'
							}
						/>
					);
				})
			},
			{
				headerName: 'Tax Code',
				field: 'taxCode',
				cellStyle: { padding: 8 },
				editable: cellEditable ? isEditableByRule("Tax Code") : false,
				resizable: false,
				width: 140,
				renderCell: withRowDisabled((rowData, rowDisabled) => {
					if (rowDisabled) {
						return (<select id={`tax-code-${rowData.row.seqId}`} disabled={!cellEditable ? true : !isEditableByRule("Tax Code")
						} name="taxCode" style={{ minWidth: 150, maxWidth: 150 }}
							data-seqid={rowData.row.seqId} value={rowData.row.taxCode}
							onChange={(event) => {
								let { field, row } = rowData;
								if (!onTaxCodeChange({ ...event, row: row })) return;
								if (props.info.modelDefId === 3) {
									props.setBroadCastTaxCode(event.target.value);
								}
								setInvoiceState({
									...invoiceState, isDirty: true,
									invoiceDocument: {
										...invoiceState.invoiceDocument,
										invoiceDocumentEditorDetails: invoiceState.invoiceDocument?.invoiceDocumentEditorDetails
											.map((e, i) => { if (e.seqId === rowData.id) { return { ...row, isDirty: true } } else return e; })
									}
								});
								setState({
									...state
								});
								setValidationonBlur(rowData.row, true);
							}}>
							<option key="0" value="">Select Tax Code</option>
							{
								invoiceState?.taxes?.map(function (item, index) {
									return <option key={index} value={item.taxCode}>{item.taxDesc}</option>
								})
							}
						</select>
						);
					}
					var taxDesc = "";
					if (invoiceState.taxes.length > 0) {
						var tax = invoiceState.taxes.filter(x => x.taxCode == rowData.row.taxCode)[0];
						if (tax) {
							taxDesc = tax.taxDesc;
						}
					}
					return <div>{taxDesc}</div>;
				}),
				renderEditCell: withRowDisabled((props, rowDisabled) => {
					if (rowDisabled) {
						return (<select id={`tax-code-edit-${props.row.seqId}`} disabled={!cellEditable ? true : !isEditableByRule("Tax Code")
						} name="taxCode" style={{ minWidth: 150, maxWidth: 150 }
						} data-seqid={props.row.seqId} value={props.row.taxCode}
							onChange={(event) => {
								let { field, row } = props;
								if (!onTaxCodeChange({ ...event, row: row })) return;
								setInvoiceState({
									...invoiceState, isDirty: true, invoiceDocument: {
										...invoiceState.invoiceDocument,
										invoiceDocumentEditorDetails: invoiceState.invoiceDocument?.invoiceDocumentEditorDetails
											.map((e, i) => { if (e.seqId === props.id) { return { ...row, isDirty: true } } else return e; })
									}
								});
								setState({
									...state
								});
								setValidationonBlur(props.row, true);
							}}>
							<option key="0" value="">Select Tax Code</option>
							{
								invoiceState?.taxes?.map(function (item, index) {
									return <option key={index} value={item.taxCode}>{item.taxDesc}</option>
								})
							}
						</select>
						);
					}
					var taxDesc = "";
					if (invoiceState.taxes.length > 0) {
						var tax = invoiceState.taxes.filter(x => x.taxCode == props.row.taxCode)[0];
						if (tax) {
							taxDesc = tax.taxDesc;
						}
					}
					return <div>{taxDesc}</div>;
				})
			},
			{
				headerName: 'Tax Amount',
				field: 'taxAmount',
				type: 'currency',
				cellStyle: cellStyle,
				align: 'right', headerAlign: 'right', width: 110,
				editable: cellEditable ? isEditableByRule("Tax Amount") : false,
				resizable: false,
				renderCell: rowData => formatNumber(rowData.row.taxAmount),
				renderEditCell: withRowDisabled((rowProps, rowDisabled) => {
					if (props.allowOverrideTaxAmount === 'Y' && rowDisabled) {
						return (
							<EditableAmountCell
								rowProps={rowProps}
								showError={false}
								isEditCellMode={true}
								amountFieldType={2}
								formatNumber={formatNumber}
								modelDefId={props.info.modelDefId}
								setBroadCastInvoiceTotal={props.setBroadCastInvoiceTotal}
								setState={setState}
								isEditableByRule={isEditableByRule}
								cellEditable={cellEditable}
								state={state}
								onIoInvoiceAmountBlur={onIoInvoiceAmountBlur}
								setValidationonBlur={setValidationonBlur}
								stateUpliftMethods={stateUpliftMethods}
								style={{ fontSize: 13, textAlign: 'right', width: '80%', marginLeft: '20%' }}
								placeholder={'Tax Amount'}
							/>
						)
					}
					return formatNumber(rowProps.value);
				})
			},
			{
				headerName: 'PO Amount',
				field: 'netCost',
				type: 'currency',
				cellStyle: cellStyle,
				align: 'right', headerAlign: 'right', width: 110,
				editable: cellEditable, resizable: false,
				renderCell: rowData => formatNumber(rowData.row.netCost),
				renderEditCell: props => { return formatNumber(props.value); },
			},
			{
				headerName: 'Consumed Amount',
				field: 'matchToDateNet',
				type: 'currency',
				cellStyle: cellStyle,
				align: 'right', headerAlign: 'right', width: 110,
				editable: cellEditable, resizable: false,
				renderCell: rowData => formatNumber(rowData.row.matchToDateNet),
				renderEditCell: props => { return formatNumber(props.value); },
			},
			{
				headerName: 'Remaining Amount',
				field: 'remainingAmount',
				type: 'currency',
				cellStyle: cellStyle,
				align: 'right', headerAlign: 'right', width: 110,
				editable: cellEditable, resizable: false,
				renderCell: rowData => formatNumber(rowData.row.remainingAmount),
				renderEditCell: props => { return formatNumber(props.value); },
			},
			{
				headerName: 'IO/PO Amount',
				field: 'poAmount',
				type: 'currency',
				cellStyle: cellStyle,
				align: 'right', headerAlign: 'right', width: 110,
				editable: cellEditable, resizable: false,
				renderCell: rowData => formatNumber(rowData.row.poAmount),
				renderEditCell: props => { return formatNumber(props.value); },
			},
			{
				headerName: 'Consumed Amount',
				field: 'consumedAmount',
				type: 'currency',
				cellStyle: cellStyle,
				align: 'right', headerAlign: 'right', width: 110,
				editable: cellEditable, resizable: false,
				renderCell: rowData => formatNumber(rowData.row.consumedAmount),
				renderEditCell: props => { return formatNumber(props.value); },
			},
			{
				headerName: 'Delivery Amount',
				field: 'deliveryAmount',
				type: 'currency',
				cellStyle: cellStyle,
				align: 'right', headerAlign: 'right', width: 110,
				editable: cellEditable, resizable: false,
				renderCell: rowData => formatNumber(rowData.row.deliveryAmount),
				renderEditCell: props => { return formatNumber(props.value); },
			},
		]
	}, [props.originalInvoiceDocumentStatus, props.isVendorChanged, state, invoiceState, invoiceState.taxes, invoiceState.invoiceDocument, invoiceState.invoiceDocument.invoiceDocumentEditorDetails, stateUpliftMethods, props.routingHistory_clickHandler, maxRoutingLevel])
	//#endregion


	const columnVisibilityModel = React.useMemo(() => ({
		// Hide columns status and traderName, the other columns will remain visible
		ioNumber: !(invoiceState.invoiceDocument.modelDefId === 2),
		ioDescription: !(invoiceState.invoiceDocument.modelDefId === 2),
		level2Key: !(invoiceState.invoiceDocument.modelDefId !== 2),
		level3Key: !(invoiceState.invoiceDocument.modelDefId !== 2),
		rTypeName: !(invoiceState.invoiceDocument.modelDefId !== 2),
		quantity: !(invoiceState.invoiceDocument.modelDefId !== 2),
		netCost: !(invoiceState.invoiceDocument.modelDefId !== 2 || !POCodeNotEmptyAndValid()),
		matchToDateNet: !(invoiceState.invoiceDocument.modelDefId !== 2 || !POCodeNotEmptyAndValid()),
		remainingAmount: !(invoiceState.invoiceDocument.modelDefId !== 2 || !POCodeNotEmptyAndValid()),
		remainingAmount: !(invoiceState.invoiceDocument.modelDefId !== 2 || !POCodeNotEmptyAndValid()),
		poAmount: !(invoiceState.invoiceDocument.modelDefId === 2),
		consumedAmount: !(invoiceState.invoiceDocument.modelDefId === 2),
		deliveryAmount: !(invoiceState.invoiceDocument.modelDefId === 2),
		siteName: invoiceState.invoiceDocument.modelDefId === 1,
	}), [props]);

	const handleCheckboxChange = (event) => {
		setShowMyLinesOnly(event.target.checked);

		const filteredRowsCount = invoiceState.invoiceDocument?.invoiceDocumentEditorDetails.filter((e) => {
			return !event.target.checked || (e.hasAuthority === 'Y' && invoiceState.invoiceDocument?.allowInvoiceEditing === true);
		}).length;

		const newPage = Math.min(Math.floor(filteredRowsCount / pageSize), page);
		setPage(newPage);
	};

	const visibleCells = React.useMemo(() => {
		return headCells.filter((e, i) => { return typeof columnVisibilityModel[e.field] == 'undefined' || columnVisibilityModel[e.field] }) || []

	}, [columnVisibilityModel, headCells])

	//const filteredRows = React.useMemo(() => {
	//	return invoiceState.invoiceDocument?.invoiceDocumentEditorDetails.filter((e, i) => {
	//		const matchesShowMyLinesOnly = !showMyLinesOnly || (e.hasAuthority === 'Y' && invoiceState.invoiceDocument?.allowInvoiceEditing === true);
	//		const matchesSearchText = visibleCells.some((col) => (((e[col.field] || '') + '').indexOf(searchText) !== -1));
	//		return matchesShowMyLinesOnly && matchesSearchText;
	//	}) || [];
	//}, [invoiceState.invoiceDocument, visibleCells, searchText, showMyLinesOnly]);

	const prioritizePartialPostRows = React.useCallback(
		(rows) => {
			if (!isPartialPostMode || !partialMoInvoiceMap?.size) {
				return rows;
			}

			const editable = [];
			const nonEditable = [];

			rows.forEach((row) => {
				const moInfo = partialMoInvoiceMap.get(String(row.seqId ?? ''))
				if (moInfo?.posted === 0) {
					editable.push(row);
				} else {
					nonEditable.push(row);
				}
			});

			return [...editable, ...nonEditable];
		},
		[isPartialPostMode, partialMoInvoiceMap]
	);

	const filteredRows = React.useMemo(() => {
		const rows =
			invoiceState.invoiceDocument?.invoiceDocumentEditorDetails.filter((e) => {
				const matchesShowMyLinesOnly =
					!showMyLinesOnly ||
					(e.hasAuthority === 'Y' &&
						invoiceState.invoiceDocument?.allowInvoiceEditing === true);

				const matchesSearchText = visibleCells.some(
					(col) => (((e[col.field] || '') + '').indexOf(searchText) !== -1)
				);

				return matchesShowMyLinesOnly && matchesSearchText;
			}) || [];

		// 🔥 PARTIAL POST PRIORITY SORT
		return prioritizePartialPostRows(rows);
	}, [
		invoiceState.invoiceDocument,
		visibleCells,
		searchText,
		showMyLinesOnly,
		prioritizePartialPostRows
	]);





	const visibleRows = React.useMemo(() => {
		const sortedRows = !sortedField ? filteredRows : stableSort(filteredRows, getComparator(orderBy, sortedField));
		const paginatedRows = sortedRows.slice(page * pageSize, page * pageSize + pageSize);
		return paginatedRows;
	}, [sortedField, page, orderBy, pageSize, filteredRows]);



	//#region camparators
	function descendingComparator(a, b, orderBy) {
		if (b[orderBy] < a[orderBy]) {
			return -1;
		}
		if (b[orderBy] > a[orderBy]) {
			return 1;
		}
		return 0;
	}


	function getComparator(order, orderBy) {
		return order === 'desc'
			? (a, b) => descendingComparator(a, b, orderBy)
			: (a, b) => -descendingComparator(a, b, orderBy);
	}
	function stableSort(array, comparator) {
		const stabilizedThis = array.map((el, index) => [el, index]);
		stabilizedThis.sort((a, b) => {
			const order = comparator(a[0], b[0]);
			if (order !== 0) {
				return order;
			}
			return a[1] - b[1];
		});
		return stabilizedThis.map((el) => el[0]);
	}
	const isCheckBoxDisabled = React.useCallback((row) => {
		if (row.hasAuthority === 'Y') return false;
		const overrideAllChecks = props.overrideAllChks;
		let companyConfig = invoiceState.invoiceDocument?.companyApprovalConfiguration;
		let routingLevels = invoiceState.invoiceDocument?.routingNumberOfApprovalLevels ?? companyConfig?.routingNumberOfApprovalLevels ?? 0;
		let isMaxed = !overrideAllChecks && (row.lineStatus % 20 !== 0) && ((row.lineStatus - 50) / 20) >= routingLevels;
		return (isMaxed);
	}, [invoiceState, props.overrideAllChks])



	const isCheckBoxDisabledValidation = (row) => {
		let _isCheckboxDisabled = (row.hasAuthority === 'N' || props.readOnly) || row.lineStatus >= upperLimit && editorMode !== Constants.APPROVAL;
		if (row.lineStatus < 50 || editorMode === Constants.MAKE_CORRECTIONS || editorMode === Constants.USER_ENTRY)
			_isCheckboxDisabled = false;
		if (row.hasAuthority === 'Y' && row.lineStatus >= 50 && !props.readOnly)
			_isCheckboxDisabled = false;
		// override previous checks and make it enabled
		if (overRideAllChecks) {
			_isCheckboxDisabled = false;
		}
		return _isCheckboxDisabled
	}
	//#endregion
	//#endregion renderer
	//for rendring borders only
	let isMakeCorrection = editorMode === Constants.MAKE_CORRECTIONS && props.originalInvoiceDocumentStatus < 50;
	//for rendring borders only end
	const { companyApprovalConfiguration } = invoiceState.invoiceDocument || {};
	const routingNumberOfApprovalLevels = companyApprovalConfiguration?.routingNumberOfApprovalLevels || 0;
	const upperLimit = 60 + routingNumberOfApprovalLevels * 20;

	// Single source of truth for which lines are selectable via "Select All".
	// Must be used both by onSelectAllClick and by the header checkbox's
	// indeterminate/checked calculation, otherwise the two can disagree (e.g.
	// after adding multiple IO/placement lines where some lines are disabled)
	// and "Select All" will appear to only select a subset of lines.
	const selectableDetailLines = React.useMemo(() => {
		const invoiceDetails = invoiceState.invoiceDocument?.invoiceDocumentEditorDetails || [];
		return invoiceDetails.filter(e => !isCheckBoxDisabledValidation(e) || props.originalInvoiceDocumentStatus < 50);
	}, [invoiceState.invoiceDocument?.invoiceDocumentEditorDetails, props.originalInvoiceDocumentStatus, editorMode, overRideAllChecks, props.readOnly, upperLimit]);

	const onSelectAllClick = React.useCallback((event) => {
		let detaillines = selectableDetailLines;
		let indeterminate = selectedRows.size > 0 && selectedRows.size < detaillines.length;
		let checked = selectedRows.size > 0 && selectedRows.size === detaillines.length;
		let isAlreadyChecked = indeterminate || checked;
		if (!isAlreadyChecked) {
			setSelectedRows(new Set(detaillines?.map(e => e.seqId)));
		}
		else {
			if (indeterminate && detaillines.length > selectedRows.size) {
				setSelectedRows(new Set(detaillines?.map(e => e.seqId)));
			}
			else {
				setSelectedRows(new Set());
			}

		}
	}, [selectableDetailLines, selectedRows])

	const shouldShowCheckbox = (props.originalInvoiceDocumentStatus >= 50 &&
		props.originalInvoiceDocumentStatus < upperLimit);
	return (

		<div style={{ width: '100%' }}>
			<Paper sx={{ width: '100%', mb: 2 }} variant="outlined">
				<Grid xs={12} sx={{ pt: 1, pl: 1, pr: 1, pb: 1 }} container item>
					<Grid item xs={5}>
						{shouldShowCheckbox ? (
							<FormControlLabel
								control={
									<Checkbox
									id="show-my-lines-checkbox"
									name="show-my-lines"
										checked={showMyLinesOnly}
										onChange={handleCheckboxChange}
										name="showMyLinesOnly"
										color="primary"
									/>
								}
								label="Show My Lines Only"
								sx={{ marginLeft: '8px' }}
							/>
						) : null}
					</Grid>
					<Grid item xs={7}>
						<Grid item container xs={12} justifyContent='end' alignItems='center'>
							<Grid item xs={4} container justifyContent='end' alignItems='end'>
								<TextField
									id="invoiceEditorGridSearch"
									name="invoice-editor-grid-search"
									sx={{
										'&': {
											paddingRight: '10px',
											fontSize: '12px'
										},
										'& .MuiInput-underline:before': {
											borderBottom: '1px solid rgba(0, 0, 0, 0.42) !important'
										},
										'& .MuiInputAdornment-root': {
											marginRight: '4px'
										}
									}}
									value={searchText}
									onChange={(event) => { setSearchText(event.target.value) }}
									InputProps={{
										startAdornment: <InputAdornment position="start">
											<SearchIcon style={{ width: 20, height: 20 }} />
										</InputAdornment>,
										endAdornment: (searchText && <IconButton
											id="clear-grid-search-button"
											size='small'
											onClick={() => { setSearchText('') }}
										>
											<ClearIcon style={{ width: 20, height: 20 }} />
										</IconButton>)
									}}
									placeholder="Search..." variant="standard" />
							</Grid>
							{(props.info.mode?.toLowerCase() != 'test' && props.info.modelDefId != 3) &&
								<Grid justifyContent='end' item>
									<>
										{getRefreshButton()}
										{getDeleteButton()}
										{getAddButton()}
										{getApproveButton()}
										{getRejectButton()}
										{getMergeButton()}
										{getSplitButton()}
									</>
								</Grid>
							}

						</Grid>
					</Grid>
				</Grid>

				<StyledTableContainer sx={{ width: '100%', height: 316, marginTop: 2 }}>
					<Table stickyHeader
						sx={{ minWidth: 750 }}
						aria-labelledby="Invoice Document Details"
					>
						<TableHead>
							<TableRow>
								{((<TableCell padding="checkbox" style={{ borderLeft: isMakeCorrection ? 'inherit' : '5px solid transparent' }}>
									<Checkbox
										id="select-all-lines-checkbox"
										name="select-all-invoice-lines"
										color="primary"
										indeterminate={selectedRows.size > 0 && selectedRows.size < selectableDetailLines.length}
										checked={selectedRows.size > 0 && selectedRows.size === selectableDetailLines.length}
										onChange={onSelectAllClick}
										disabled={(!overRideAllChecks) && props.readOnly && editorMode !== Constants.APPROVAL}
										inputProps={{
											'aria-label': 'select all records',
										}}
									/>
								</TableCell>))}
								{visibleCells.map((headCell, i) => (
									<TableCell
										key={i}
										style={{ width: headCell.width || 'unset', minWidth: headCell.width || 'unset', maxWidth: headCell.width || 'unset' }}
										align={headCell.headerAlign}
										padding={headCell.disablePadding ? 'none' : 'normal'}
									>
										<TableSortLabel
											id={`sort-${headCell.field}`}
											hideSortIcon={!(headCell.sortable || typeof headCell.sortable == 'undefined')}
											active={headCell.field === sortedField}
											direction={sortedField === headCell.field ? orderBy : 'asc'}
											onClick={(event) => {
												const isAsc = sortedField === headCell.field && orderBy === 'asc';
												setSortedField(sortedField === headCell.field && orderBy === 'desc' ? '' : headCell.field)
												setOrderBy(isAsc ? 'desc' : 'asc');

											}}
										>
											{headCell.headerName}
										</TableSortLabel>

									</TableCell>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							{visibleRows.map((row, index) => {

								//checkbox // authority		readyonly	line status>=upperlimit		mode= approval	mode= MakeCorrections
								//and	//enable	  1				0			0							0				1				
								//or	//disable	  0				1			1							1				0				

								const isItemSelected = selectedRows.has(row.seqId);
								let isCheckboxDisabled = (row.hasAuthority === 'N') || row.lineStatus > upperLimit || editorMode !== Constants.APPROVAL;
								if (row.hasAuthority === 'Y' && row.lineStatus >= 50) {
									isCheckboxDisabled = false;
								}
								if (row.lineStatus < 50 || editorMode === Constants.MAKE_CORRECTIONS || (row.lineStatus <= 50 && editorMode === Constants.USER_ENTRY)) {
									if (editorMode === Constants.APPROVAL && row.hasAuthority === 'N') {
										isCheckboxDisabled = true;
									} else {
										isCheckboxDisabled = false;
									}
								}
								if (props.readOnly && editorMode !== Constants.APPROVAL)
									isCheckboxDisabled = true;
								// override previous checks and make it enabled
								if (overRideAllChecks) {
									isCheckboxDisabled = false;
								}
								let borderColor = row.isNew ? '5px solid transparent' : (row.hasAuthority === 'Y') ? '5px solid green' : '5px solid grey';
								if (row.lineStatus < 50 || (row.lineStatus % 20 === 0 && row.lineStatus >= 60) || row.lineStatus > upperLimit) {
									borderColor = '5px solid transparent';
								} else if ((overRideAllChecks && row.lineStatus > upperLimit) || (isCheckboxDisabled && row.hasAuthority === 'Y') || props.originalInvoiceDocumentStatus === 60) {
									borderColor = '5px solid transparent';
								}
								let styleBody = isMakeCorrection ? {} : { borderLeft: borderColor };

								const key = String(row.seqId ?? '');
								const isPostedLine = isPartialPostMode && Number(partialMoInvoiceMap?.get(key)?.posted) === 1;
								const rowSx = { cursor: 'pointer', ...(isPostedLine ? { backgroundColor: '#f5f5f5' } : {}) };
								return (

									!isCheckboxDisabled ?
										<TableRow
											id={`invoice-grid-row-${row.seqId}`}
											hover
											role="checkbox"
											aria-checked={isItemSelected}
											tabIndex={-1}
											key={row.seqId}
											selected={isItemSelected}
											sx={rowSx}
											className={isPostedLine ? 'partial-posted-row' : ''}
										>
											<TableCell padding="checkbox"
												style={{ ...styleBody }}
											>
												<Checkbox
															id={`select-line-${row.seqId}`}
																name={`select-invoice-line-${row.seqId}`}
													disabled={isCheckBoxDisabled(row)}
													color="primary"
													onChange={(event) => {
														if (event.target.checked) {
															setSelectedRows(prevSelectedRows => new Set([...prevSelectedRows, row.seqId]));
														} else {
															setSelectedRows(prevSelectedRows => {
																const newSelectedRows = new Set(prevSelectedRows);
																newSelectedRows.delete(row.seqId);
																return newSelectedRows;
															});
														}
													}}
													checked={isItemSelected}
													inputProps={{
														'aria-labelledby': 'select row',
													}}

												/>
											</TableCell>
											{visibleCells.map((e, i) => {
												return (
													<TableCell

														component="td"
														key={i}
															id={`invoice-grid-cell-${row.seqId}-${e.field}`}
														style={{ width: e.width || 'unset', minWidth: e.width || 'unset', maxWidth: e.width || 'unset' }}
														align={e.align}
														scope="row"
														padding="none"
													>
														{(e?.renderEditCell && e?.renderEditCell({ row: row, field: e.field, id: row.seqId, value: row[e.field] }))
															|| row[e.field]}
													</TableCell>
												)
											})}

										</TableRow>
										:

										<TableRow
											id={`invoice-grid-row-${row.seqId}`}
											hover
											role="checkbox"
											aria-checked={isItemSelected}
											tabIndex={-1}
											key={row.seqId}
											selected={false}
											sx={rowSx}
										>
											{((<TableCell padding="checkbox"
												style={{ ...styleBody }}>
												<Checkbox
															id={`select-line-disabled-${row.seqId}`}
																name={`select-invoice-line-disabled-${row.seqId}`}
													color="primary"
													onChange={(event) => {
														if (event.target.checked) { setSelectedRows(new Set([...selectedRows, row.seqId])) } else {
															setSelectedRows(new Set([...selectedRows].filter(e => e !== row.seqId)))
														}
													}}
													checked={false}
													inputProps={{
														'aria-labelledby': 'select row',
													}}
													disabled={/*(!overRideAllChecks) && */(isCheckboxDisabled || isCheckBoxDisabled(row))}
												/>
											</TableCell>))}
											{visibleCells.map((e, i) => (
												<TableCell

													component="td"
													key={i}
															id={`invoice-grid-cell-${row.seqId}-${e.field}`}
													style={{ width: e.width || 'unset', minWidth: e.width || 'unset', maxWidth: e.width || 'unset' }}
													align={e.align}
													scope="row"
													padding="none"
												>
													{(e?.renderCell && e?.renderCell({ row: row, field: e.field, id: row.seqId, value: row[e.field] }))
														|| row[e.field]}
												</TableCell>
											))}

										</TableRow>
								);
							})}
							{invoiceState.invoiceDocument?.invoiceDocumentEditorDetails <= 0 && (
								<TableRow
								>
									<TableCell align='center' style={{ height: 350, borderBottom: 'none' }} colSpan={visibleCells.length + (cellEditable ? 2 : 0)} >
										<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', left: '0px', right: '0px' }}>
											No rows
										</div>
									</TableCell>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</StyledTableContainer>
				<StyledTablePagination
					id="invoice-grid-pagination"
					SelectProps={{ inputProps: { name: 'invoice-grid-rows-per-page' } }}
					rowsPerPageOptions={[5, 10, 25]}
					component="div"
					count={filteredRows.length}
					rowsPerPage={pageSize}
					page={((getLastPage() - 1 < page) || page < 0) ? 0 : page}
					onRowsPerPageChange={(event) => { setpageSize(event.target.value) }}
					onPageChange={(event, newpage) => { setPage(newpage) }}
				/>
			</Paper>

			<Level2Lookup info={level2Info} key="Level2LookupEditorGrid" onClose={level2Dialog_closeHandler} />
			<Level3Lookup info={level3Info} key="Level3LookupEditorGrid" onClose={level3Dialog_closeHandler} />
			<CostCodesLookup info={costCodesInfo} key="CostCodesLookupEditorGrid" onClose={costCodesDialog_closeHandler} />

			<Dialog key="DeleteRecordsEditorGrid"
				open={state.openDeleteConfirmation}
				aria-labelledby="draggable-dialog-title"
			>
				<DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
					Delete Records
				</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Are you sure you want to delete this record ?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button id="confirm-delete-record-button" onClick={deleteRecord} color="primary">
						Yes
					</Button>
					<Button id="cancel-delete-record-button" autoFocus onClick={closeDeleteDialog} color="primary">
						No
					</Button>
				</DialogActions>
			</Dialog>
			<Dialog key="DeleteSelectedRecordsEditorGrid"
				open={state.openDeleteSelectedConfirmation}
				aria-labelledby="draggable-dialog-title"
			>
				<DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
					Delete Records
				</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Are you sure you want to delete selected records ?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button id="confirm-delete-selected-button" onClick={deleteSelectedRecord} color="primary">
						Yes
					</Button>
					<Button id="cancel-delete-selected-button" autoFocus onClick={closeDeleteSelectedDialog} color="primary">
						No
					</Button>
				</DialogActions>
			</Dialog>
			<Dialog
				open={openCommentDialog}
				onClose={() => setOpenCommentDialog(false)}
				aria-labelledby="comment-dialog-title"
				maxWidth="md"
				fullWidth
				style={{ padding: '2' }}
			>
				<DialogTitle id="comment-dialog-title">Approval/ Rejection Comments
					{actionType === 'reject' && <span style={{ color: 'red' }}> *</span>}
				</DialogTitle>
				<DialogContent>
					<div style={{ border: '1px solid darkgrey', padding: '8px 16px' }}>
						<DialogContentText style={{ color: 'black' }}>
							{nextleveldesc}
						</DialogContentText>
						<textarea
							margin="dense"
							id="comment"
							label="Comments"
							type="text"
							rows={6}
							style={{ width: '100%', minHeight: '100px', border: '1px solid darkgrey', resize: 'none', padding: '8px' }}
							value={comment}
							onChange={(e) => setComment(e.target.value)}
						/>
						<DialogActions style={{ padding: 0 }}>
							<Button id="save-comment-button" onClick={handleCommentDialogSave} color="primary" style={{ backgroundColor: '#008CBA', color: 'white', cursor: 'pointer' }}>
								Save
							</Button>
							<Button id="cancel-comment-button" onClick={() => setOpenCommentDialog(false)} color="primary" style={{ backgroundColor: '#e7e7e7', color: 'black', cursor: 'pointer' }}>
								Cancel
							</Button>
						</DialogActions>
					</div>
				</DialogContent>


			</Dialog>
		</div>
	);
}
//#endregion


const EditableAmountCell = ({
	rowProps,
	showError,
	isEditCellMode,
	amountFieldType,
	formatNumber,
	modelDefId,
	setBroadCastInvoiceTotal,
	setState,
	isEditableByRule,
	cellEditable,
	state,
	onIoInvoiceAmountBlur,
	setValidationonBlur,
	stateUpliftMethods,
	style,
	placeholder,
}) => {
	const { state: useInvoiceState, setState: setInvoiceState } = useInvoice();
	const inputRef = React.useRef(null);
	const cursorPosRef = React.useRef({ start: null, end: null });

	// The caller (grid column config) already derives cellEditable as
	// `cellEditable && !isRowPlacementLocked(row)`, where isRowPlacementLocked
	// locks the field purely based on whether this line has placements
	// attached (row.placements non-empty) — regardless of session mode. Trust
	// that single source of truth here instead of re-deriving the same rule.
	const readOnly = !cellEditable
		? true
		: !isEditableByRule(
			useInvoiceState.invoiceDocument.modelDefId === 2 ? 'Amount' : 'Invoice Net Amount'
		);

	const errorClass = showError ? ' MuiInput-input-error' : '';

	const [mode, setMode] = React.useState('text');
	const [rawValue, setRawValue] = React.useState(() =>
		formatNumber(parseFloat(rowProps.row[rowProps.field]?.toString().replace(/,/g, '') || '0.00')) || '0.00'
	);
	const [formattedValue, setFormattedValue] = React.useState(() =>
		formatNumber(rowProps.row[rowProps.field]) || '0.00'
	);

	React.useEffect(() => {
		if (mode === 'number') return
		const externalValue = rowProps.row[rowProps.field];
		const raw = parseFloat(externalValue?.toString().replace(/,/g, '') || '0.00');
		setRawValue(raw.toFixed(2));  // Always ensure 2 decimal places on update
		setFormattedValue(formatNumber(externalValue) || '0.00');
	}, [rowProps.row[rowProps.field]]);

	React.useLayoutEffect(() => {
		const { start, end } = cursorPosRef.current;
		if (inputRef.current && start !== null && end !== null) {
			inputRef.current.setSelectionRange(start, end);
			cursorPosRef.current = { start: null, end: null };
		}
	});

	const updateExternal = (value) => {
		const numeric = parseFloat(value?.toString().replace(/,/g, '') || '0');
		if (isNaN(numeric)) {
			return;
		}
		const currentTaxRows = rowProps.row.invoiceDocumentDetailTaxes || [];
		let updatedTaxRows = currentTaxRows.map(row => ({ ...row }));
		if (amountFieldType === 2) {
			if (updatedTaxRows.length > 0) {
				const previousAmount = updatedTaxRows.reduce(
					(total, row) => total + (parseFloat(row.taxAmount) || 0),
					0
				);
				updatedTaxRows.forEach((row, index) => {
					const share = previousAmount !== 0
						? (parseFloat(row.taxAmount) || 0) / previousAmount
						: index === 0 ? 1 : 0;
					row.taxAmount = parseFloat((numeric * share).toFixed(2));
				});
			} else if (!rowProps.row.taxCode) {
				updatedTaxRows = [{
					companyCode: rowProps.row.companyCode,
					invoiceDocumentId: rowProps.row.invoiceDocumentId,
					seqId: rowProps.row.seqId,
					taxCode: 'Dummy',
					taxTypeCode: 'Dummy',
					taxPrc: 0,
					taxAmount: numeric
				}];
			}
		}
		setInvoiceState((prev) => ({
			...prev,
			isDirty: true,
			invoiceDocument: {
				...prev.invoiceDocument,
				invoiceDocumentEditorDetails: prev.invoiceDocument.invoiceDocumentEditorDetails.map((entry) =>
					entry.seqId === rowProps.id
						? {
							...entry,
							[rowProps.field]: numeric,
							...(amountFieldType === 2 ? { invoiceDocumentDetailTaxes: updatedTaxRows } : {}),
							...({ isTaxManuallyChanged: amountFieldType === 2 ? true : entry.isTaxManuallyChanged }),
							isDirty: true,
						}
						: entry
				),
			},
		}));

		return updatedTaxRows;
	};


	const updateRow = (rowData) => {
		if (!rowData) return;
		setInvoiceState((prev) => ({
			...prev,
			isDirty: true,
			invoiceDocument: {
				...prev.invoiceDocument,
				invoiceDocumentEditorDetails: prev.invoiceDocument.invoiceDocumentEditorDetails.map((entry) =>
					entry.seqId === rowData.id ? rowData.row : entry
				),
			},
		}));
	};

	const handleFocus = () => {
		cursorPosRef.current = { start: null, end: null };
		setMode('number');
		// On focus, ensure rawValue is formatted with 2 decimal places.
		setRawValue(parseFloat(rawValue).toFixed(2));
	};

	const handlePaste = (e) => {
		if (readOnly) return;

		e.preventDefault();

		const pasteText = e.clipboardData.getData('text') || '';

		// Strip everything except digits, dot, minus
		const cleaned = pasteText.replace(/[^0-9.\-]/g, '');

		if (!cleaned) {
			return;
		}

		// Keep behavior consistent with typing: work in "number" mode
		setMode('number');
		setRawValue(cleaned);

		// Only push out if it's a complete number
		if (isCompleteNumber(cleaned)) {
			const numericVal = Number(cleaned);
			const fixed = numericVal.toFixed(2);

			if (
				isEditCellMode &&
				amountFieldType === 1 &&
				modelDefId === 3 &&
				typeof setBroadCastInvoiceTotal === 'function'
			) {
				setBroadCastInvoiceTotal(fixed);
			}
		}

		// Put cursor at end of pasted value
		requestAnimationFrame(() => {
			if (inputRef.current) {
				const len = cleaned.length;
				inputRef.current.setSelectionRange(len, len);
				cursorPosRef.current = { start: len, end: len };
			}
		});
	};


	const isCompleteNumber = (v) => /^-?(?:\d+|\d*\.\d+)$/.test(v);

	const handleChange = (e) => {
		cursorPosRef.current = {
			start: e.target.selectionStart,
			end: e.target.selectionEnd,
		};

		const val = e.target.value;

		// 1) Allow empty during editing
		if (val === '') {
			setRawValue('');
			return;
		}

		// 2) Allow transient minus/decimal states while typing
		if (val === '-' || val === '.' || val === '-.') {
			setRawValue(val);
			return;
		}

		// 3) Clean pasted value (remove everything except digits, dot, minus)
		const cleaned = val.replace(/[^0-9.\-]/g, '');

		// After cleaning, we might end up with empty or just transient states
		if (cleaned === '') {
			setRawValue('');
			return;
		}
		if (cleaned === '-' || cleaned === '.' || cleaned === '-.') {
			setRawValue(cleaned);
			return;
		}

		// 4) Validate numeric *shape* on the cleaned value
		if (!/^-?\d*\.?\d*$/.test(cleaned)) {
			// Ignore invalid edit – keep previous value
			return;
		}

		// 5) Accept the cleaned value for display in "number" mode
		setRawValue(cleaned);

		// 6) Only push updates out when it’s a complete number
		if (isCompleteNumber(cleaned)) {
			const numericVal = Number(cleaned);
			const fixed = numericVal.toFixed(2);

			if (
				isEditCellMode &&
				amountFieldType === 1 &&
				modelDefId === 3 &&
				typeof setBroadCastInvoiceTotal === 'function'
			) {
				setBroadCastInvoiceTotal(fixed);
			}
		}
	};


	//const handleChange = (e) => {
	//	cursorPosRef.current = {
	//		start: e.target.selectionStart,
	//		end: e.target.selectionEnd,
	//	};

	//	const val = e.target.value;

	//	// Allow empty during editing
	//	if (val === '') {
	//		setRawValue('');
	//		// Don't update external state yet
	//		return;
	//	}

	//	// Allow transient minus/decimal states while typing
	//	if (val === '-' || val === '.' || val === '-.') {
	//		setRawValue(val);
	//		// Don't update external state yet
	//		return;
	//	}

	//	// If it doesn't match a numeric shape, ignore the change
	//	if (!/^-?\d*\.?\d*$/.test(val)) {
	//		return;
	//	}

	//	// Valid numeric *shape* while typing
	//	setRawValue(val);

	//	// Only push updates when it's a complete number (no trailing dot / stray minus)
	//	if (isCompleteNumber(val)) {
	//		const numericVal = Number(val);
	//		setFormattedValue(formatNumber(numericVal.toFixed(2)));
	//		updateExternal(numericVal);

	//		// Broadcast if needed
	//		if (
	//			isEditCellMode &&
	//			amountFieldType === 1 &&
	//			modelDefId === 3 &&
	//			typeof setBroadCastInvoiceTotal === 'function'
	//		) {
	//			setBroadCastInvoiceTotal(numericVal.toFixed(2));
	//		}
	//	}
	//};


	const handleBlur = () => {
		// Normalize transient/empty states to 0.00
		let val = rawValue;
		if (val === '' || val === '-' || val === '.' || val === '-.') {
			val = '0';
		}

		// Finalize number
		const num = Number(val);
		const fixed = isNaN(num) ? '0.00' : Number(num).toFixed(2);
		const formatted = isNaN(num) ? '0.00' : formatNumber(num);
		const updatedTaxRows = updateExternal(Number(fixed));
		const updatedRow = {
			...rowProps.row,
			[rowProps.field]: Number(fixed),
			...(amountFieldType === 2
				? {
					invoiceDocumentDetailTaxes: updatedTaxRows,
					isTaxManuallyChanged: true
				}
				: {}),
			isDirty: true
		};
		setRawValue(fixed);
		setFormattedValue(formatted);
		setMode('text');

		if (updatedRow.taxCode) {
			onIoInvoiceAmountBlur(null, updatedRow);
		}
		setValidationonBlur(updatedRow, true);
		updateRow({ ...rowProps, row: updatedRow });
	};

	//const handleBlur = () => {
	//	const num = parseFloat(rawValue);
	//	const formatted = isNaN(num) ? '0.00' : formatNumber(num);
	//	setFormattedValue(formatted);
	//	setMode('text');

	//	if (rowProps.row.taxCode) {
	//		onIoInvoiceAmountBlur(null, rowProps.row);
	//	}
	//	setValidationonBlur(rowProps.row, true);
	//	updateRow(rowProps);
	//};

	//const handleChange = (e) => {

	//	cursorPosRef.current = {
	//		start: e.target.selectionStart,
	//		end: e.target.selectionEnd
	//	};

	//	const val = e.target.value;

	//	if (val === '' || isNaN(val)) {

	//		const numericVal = parseFloat(0).toFixed(2); 
	//		const formatted = formatNumber(numericVal);
	//		setRawValue('0.00');
	//		setFormattedValue(formatted);
	//		return; 
	//	}

	//	// Validate input with regex to ensure it's a valid number
	//	if (/^-?\d*\.?\d*$/.test(val)) {
	//		// Parse the value, then round to 2 decimals for rawValue and formattedValue
	//		const numericVal = parseFloat(val).toFixed(2); // Ensure 2 decimal places
	//		const formatted = formatNumber(numericVal); // Format number according to your requirements

	//		// Update state values
	//		setRawValue(val);
	//		setFormattedValue(formatted);

	//		// Trigger external update to ensure the backend/state gets the updated value
	//		updateExternal(val);

	//		// Broadcasting the total if the condition applies
	//		if (
	//			isEditCellMode &&
	//			amountFieldType === 1 &&
	//			modelDefId === 3 &&
	//			typeof setBroadCastInvoiceTotal === 'function'
	//		) {
	//			setBroadCastInvoiceTotal(numericVal);
	//		}
	//	}
	//};

	return (
		<div title={formattedValue}>
			<input
				id={`${rowProps.field}-${rowProps.id}`}
				ref={inputRef}
				type="text"
				className={`MuiInputBase-input MuiInput-input${errorClass}`}
				style={style}
				value={mode === 'number' && !readOnly ? rawValue : formattedValue}
				maxLength={15}
				onFocus={handleFocus}
				onBlur={handleBlur}
				onChange={handleChange}
				onPaste={handlePaste}
				readOnly={readOnly}
				placeholder={placeholder}
				aria-invalid="false"
				onKeyDown={(e) => {

					if (e.ctrlKey || e.metaKey) return;

					const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'];
					if (!/[0-9.\-]/.test(e.key) && !allowedKeys.includes(e.key)) {
						e.preventDefault();
					}
				}}
			/>
		</div>
	);
};



